import React, { useState, useEffect } from 'react'
import { T, GameLogos, TeamTag, Tabs, Sheet, Stat, GradeRing, TierBadge, RatingBadge, Spinner, pct, probColor, confColor, edgeColor, gradeLetter, gradeColor, tierFromProb, bookName, bookUrl, fmtOdds, payout100, Avatar, VerdictChip, FTSY_VLEVEL, tdColor, playColor, shownProb } from './ui'
import { track } from './track'
import { getNFLCoverageProfile, getNFLPlayer, getNFLPlayerProps, getNFLGame, getNFLGamePlan, getNFLGameRead, getNFLPlayerMatchup, getNFLPlayerSplits, getNFLPlayerIntel, getNFLDefense, getNFLBookOdds, getNFLBookOddsLadder, runNFLJob, scratchNFLPlayer, getNFLValidation, getNFLStatus, getNFLAudit, getNFLMarketAudit, getNFLOps, setNFLOps, getNFLCombo, getNFLReferralsAdmin, nflReferralPayout, nflMakeRefCode, nflAttributeReferral, getNFLScorecard, getKalshiLink, getNFLMarket, MARKET_KEY } from './api'
import { shareNflThursday, shareNflTop10, shareNflMarket, shareNflGameplan, shareNflMatchupPlan, shareNflSpots, shareNflRecap, shareNflPaydirt } from './share'
import { sharePick } from './share'
import { FavStar } from './favorites.jsx'
import { LogPickButton } from './community.jsx'
import { nickify, playText, teamNick } from './plain'

// Line shop — every US book's price for this bet, best first. Answers "which book
// has the best number?" (LINEBRKR's "find the book" pillar) instead of a single DK line.
function LineShop({ e, isTD, shownLine, season, week }){
  const [d,setD] = useState(undefined)
  const [all,setAll] = useState(false)
  const [lad,setLad] = useState(null)   // full over/under ladder (alt lines, when enabled)
  useEffect(()=>{ let live=true; setD(undefined); setLad(null)
    if(!e.gsis_id){ setD(null); return ()=>{live=false} }
    getNFLBookOdds(e.gsis_id, e.market||'Receptions', season, week).then(r=>{ if(live) setD(r && !r._sample ? r : null) })
    getNFLBookOddsLadder(e.gsis_id, e.market||'Receptions', season, week).then(r=>{ if(live) setLad(r) })
    return ()=>{live=false}
  },[e.gsis_id, e.market, season, week])

  const books = (d && d.books) || []
  const best = (d && d.best) || books[0] || null
  const bestOdds = best ? best.over : e.book_over_odds
  const bestBook = (best && best.book) || e.book_used
  const line = (best && best.line!=null) ? best.line : (e.book_line!=null ? e.book_line : shownLine)

  // Nothing priced anywhere yet — say so plainly (props post ~1–2 days pre-kick).
  if(bestOdds==null)
    return (
      <div style={{fontSize:11.5,color:T.muted,background:T.card2,border:`1px solid ${T.border}`,
        borderRadius:10,padding:"9px 12px",marginBottom:12,lineHeight:1.4}}>
        No book line posted yet — NFL props usually post ~1–2 days before kickoff. Live odds and the best price across books show up here once they do.
      </div>
    )

  const shown = all ? books : books.slice(0,6)
  const worst = books.length>1 ? books[books.length-1] : null
  const gain = (worst && worst.over!=null && bestOdds!=null) ? payout100(bestOdds)-payout100(worst.over) : 0
  return (
    <div style={{marginBottom:12}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8,
        background:T.greenDim,border:`1px solid ${T.green}`,borderRadius:10,padding:"9px 12px"}}>
        <span style={{fontSize:12,color:T.text,fontWeight:700}}>💰 Best {fmtOdds(bestOdds)}
          <span style={{color:T.muted,fontWeight:600,marginLeft:6}}>{bookName(bestBook)} · {isTD?'Anytime TD':playText(e.market, line)}</span></span>
        {e.edge_pct!=null && <span style={{fontSize:12,fontWeight:800,fontFamily:T.mono,color:e.edge_pct>=0?T.green:T.red}}>
          {e.edge_pct>=0?'+':''}{e.edge_pct.toFixed(1)}% edge</span>}
      </div>
      {/* One-tap to the book — prefer a pre-filled slip link, else the book's affiliate/home URL. */}
      {(() => { const slip = best && best.over_link; const url = slip || bookUrl(bestBook)
        if (!url) return null
        return (
          <a href={url} target="_blank" rel="noopener noreferrer"
            style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,marginTop:8,
              background:T.green,color:"#04140D",fontWeight:900,fontSize:13.5,borderRadius:10,
              padding:"11px 0",textDecoration:"none",cursor:"pointer"}}>
            {`See it at ${bookName(bestBook)}`} ↗
          </a>
        ) })()}
      {gain>0 && <div style={{fontSize:10.5,color:T.muted,margin:"6px 2px 0"}}>
        $100 wins <b style={{color:T.green}}>${payout100(bestOdds)}</b> here — ${gain} more than the worst book on the board.</div>}
      {books.length>1 && (
        <div style={{marginTop:8,background:T.card,border:`1px solid ${T.border}`,borderRadius:10,overflow:"hidden"}}>
          {shown.map((b,i)=>{ const slip=b.over_link; const url=slip||bookUrl(b.book)
            const row=(<>
              <span style={{fontSize:12,color:T.text,fontWeight:i===0?700:500}}>{i===0?'★ ':''}{bookName(b.book)}{url?<span style={{color:slip?T.green:T.muted2,marginLeft:5,fontSize:slip?10:11,fontWeight:slip?800:400}}>{slip?'+ slip ↗':'↗'}</span>:null}</span>
              <span style={{fontFamily:T.mono,fontSize:12,color:i===0?T.green:T.muted2}}>{isTD?'':`O${b.line} `}{fmtOdds(b.over)}</span>
            </>)
            const st={display:"flex",alignItems:"center",justifyContent:"space-between",textDecoration:"none",
              padding:"7px 12px",borderTop:i?`1px solid ${T.border}`:"none",background:i===0?T.greenDim:"transparent"}
            return url
              ? <a key={b.book+i} href={url} target="_blank" rel="noopener noreferrer" style={{...st,cursor:"pointer"}}>{row}</a>
              : <div key={b.book+i} style={st}>{row}</div>
          })}
          {books.length>6 && (
            <button onClick={()=>setAll(a=>!a)} style={{width:"100%",padding:"7px 0",fontSize:11,fontWeight:700,
              color:T.green,background:T.card2,border:"none",borderTop:`1px solid ${T.border}`,cursor:"pointer"}}>
              {all?'Show fewer':`Show all ${books.length} books`}</button>
          )}
        </div>
      )}
      {d && d.consensus!=null && <div style={{fontSize:10,color:T.faint,margin:"6px 2px 0"}}>
        Consensus fair (median de-vig across {books.length||'the'} books): {Math.round(d.consensus*100)}%</div>}
      {/* Value across the ladder — every posted rung (standard + alternate) with the
          model's edge at that line, best-value rung starred. Only when >1 rung exists
          (i.e. alt lines are enabled server-side); a single rung adds no info. */}
      {!isTD && lad && lad.rungs && lad.rungs.length>1 && (() => {
        const bvLine = lad.best_value && lad.best_value.line
        return (
          <div style={{marginTop:10}}>
            <div style={{fontSize:10.5,color:T.muted,fontWeight:700,letterSpacing:"0.04em",marginBottom:5}}>
              VALUE ACROSS THE LADDER</div>
            <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,overflow:"hidden"}}>
              <div style={{display:"flex",fontSize:10,color:T.muted,padding:"6px 12px",letterSpacing:"0.04em",borderBottom:`1px solid ${T.border}`}}>
                <span style={{flex:1}}>LINE</span><span style={{width:70,textAlign:"right"}}>BEST</span>
                <span style={{width:56,textAlign:"right"}}>MODEL</span><span style={{width:56,textAlign:"right"}}>EDGE</span>
              </div>
              {lad.rungs.map((r,i)=>{ const bv = r.line===bvLine
                return (
                <div key={i} style={{display:"flex",alignItems:"center",padding:"7px 12px",
                  borderTop:i?`1px solid ${T.border}`:"none",background:bv?T.greenDim:"transparent"}}>
                  <span style={{flex:1,fontSize:12,color:T.text,fontWeight:bv?800:500,fontFamily:T.mono}}>
                    {bv?'★ ':''}O{r.line}{r.alt?'':<span style={{color:T.faint,fontSize:10,marginLeft:5}}>std</span>}</span>
                  <span style={{width:70,textAlign:"right",fontFamily:T.mono,fontSize:12,color:T.muted2}}>{fmtOdds(r.best_over)}</span>
                  <span style={{width:56,textAlign:"right",fontFamily:T.mono,fontSize:12,color:T.muted}}>{r.model_prob!=null?`${Math.round(r.model_prob*100)}%`:'—'}</span>
                  <span style={{width:56,textAlign:"right",fontFamily:T.mono,fontSize:12,fontWeight:700,
                    color:r.edge_pct==null?T.faint:(r.edge_pct>=0?T.green:T.red)}}>
                    {r.edge_pct==null?'—':`${r.edge_pct>=0?'+':''}${r.edge_pct}%`}</span>
                </div>
              )})}
            </div>
            <div style={{fontSize:10,color:T.faint,margin:"5px 2px 0",lineHeight:1.5}}>
              ★ = the rung where our model most beats the price. Edge is a value signal on the number, not a wager size.
            </div>
          </div>
        )
      })()}
    </div>
  )
}

// The stat field (from /nfl/players/{id} logs) that matches each market.
const LOG_FIELD = { 'Receptions':'rec', 'Rec Yds':'rec_yds', 'Rush Yds':'rush_yds',
  'Pass Yds':'pass_yds', 'Pass TDs':'pass_td', 'Anytime TD':'tds' }
const isTD = e => e.market === 'Anytime TD'

// ── projection breakdown ─────────────────────────────────────────────────────
// Prefer the real v2 component stack from the backend; fall back to an
// illustrative one for sample rows that carry no components.
// Only the REAL backend component stack — no synthetic fallback. Rows without a
// projection (trending/analytics taps) show no breakdown rather than a fake one.
function components(e){
  if (!e.components) return []
  const notes = { 'Defense matchup':`vs ${teamNick(e.opp)}`, 'Game script':'Vegas total / spread',
    'PFF coverage':'coverage matchup', 'NGS efficiency':'separation / RYOE / CPOE',
    'Rest / home':'schedule spot', 'Pace':'plays/game', 'Scheme':'man vs zone',
    'Weather':'wind / temp', 'redzone':'red-zone role' }
  return Object.entries(e.components)
    .filter(([, v]) => v != null && Math.abs(v - 1) > 1e-6)   // only signals that moved the needle
    .map(([label, mult]) => ({ label, mult, note: notes[label] || '' }))
}
function projVal(e){
  // Use the backend's real projection (same value the board card shows). Never
  // fabricate one from line×prob — that both disagreed with the card and rendered
  // literal "NaN" on taps that carry no line.
  if(e.market==='Anytime TD') return null
  return e.proj != null ? e.proj : null
}
// The % to show for a play: P(over the book line) when it's priced, else P(over the line
// shown) — hit_prob. Never prob_over on its own: that's the flat-canonical-line volume proxy,
// and showing it next to a different line read "79% · o1.5" when the board said 67.9%.
const _shownProb = shownProb   // one shared rule (ui.jsx) — hit_prob first
function why(e){
  if (e.prob_over == null) return e.note || ''
  const sp = _shownProb(e)
  const conf = e.confidence ? `, ${e.confidence} confidence` : ''
  const edge = e.edge_pct>0 ? ` +${e.edge_pct.toFixed(1)}% edge vs the book.` : ''
  const tail = `${pct(sp)} to ${e.market==='Anytime TD'?'score':'hit'}${conf}. ${e.note?e.note+'. ':''}${edge}`
  if (e.market==='Anytime TD') return `Model gives ${tail}`
  const dir = sp>=0.5 ? 'over' : 'under'
  // Guard: never let a missing market/line leak the literal word "undefined" into copy.
  const mkt = [e.market, e.line].filter(v => v != null && v !== '').join(' ')
  return `Model leans ${dir}${mkt ? ' ' + mkt : ''} — ${tail}`
}
// "Due to Score" — the friendly TD-regression read. Green when a player keeps
// earning scoring chances without the TD (positive regression); amber when he's
// over-converting and likely to cool off. Hidden entirely when the backend returns
// null (thin sample or red-zone table not built) — never a hollow signal.
function DueToScore({ dts }){
  if(!dts) return null
  const tone = dts.tone==='good' ? T.green : dts.tone==='warn' ? T.amber : T.muted2
  const bg   = dts.tone==='good' ? T.greenDim : T.card2
  const carry = dts.season && dts.season !== 2026
  return (
    <div style={{ background:bg, border:`1px solid ${tone}55`, borderRadius:12, padding:'11px 13px', marginBottom:12 }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10 }}>
        <div style={{ fontSize:13.5, fontWeight:900, color:tone, letterSpacing:'0.02em' }}>
          {dts.tone==='good' ? '📈 ' : dts.tone==='warn' ? '🔥 ' : '• '}{dts.tag}
        </div>
        <div style={{ fontFamily:T.mono, fontSize:12, color:T.muted, whiteSpace:'nowrap' }}>
          <b style={{ color:T.text }}>{dts.earned}</b> earned · <b style={{ color:T.text }}>{dts.scored}</b> scored
        </div>
      </div>
      <div style={{ fontSize:11.5, color:T.muted2, marginTop:6, lineHeight:1.45 }}>{dts.blurb}</div>
      <div style={{ fontSize:10, color:T.muted, marginTop:6, letterSpacing:'0.03em' }}>
        From red-zone & goal-line chances{carry ? ` · ${dts.season} form` : ''} · research only
      </div>
    </div>
  )
}
// Player efficiency — EPA per play (the modern DVOA-equivalent), with a league percentile
// vs positional peers. Front-loaded on the profile so per-play quality reads at a glance.
function EpaPanel({ epa }){
  if(!epa) return null
  const rows = []
  if(epa.rush)      rows.push(['Rush', epa.rush.epa_per_rush, epa.rush.success, epa.rush.pct, `${epa.rush.att} att`])
  if(epa.receiving) rows.push(['Rec',  epa.receiving.epa_per_target, epa.receiving.success, epa.receiving.pct, `${epa.receiving.targets} tgt`])
  if(epa.passing)   rows.push(['Pass', epa.passing.epa_per_dropback, epa.passing.success, epa.passing.pct, `${epa.passing.dropbacks} db`])
  if(!rows.length) return null
  const pctColor = _epaPctColor
  const carry = epa.season && epa.season !== 2026
  return (
    <div style={{ background:T.card, border:`1px solid ${T.border}`, borderRadius:12, padding:'11px 13px', marginBottom:12 }}>
      <div style={{ fontSize:10.5, color:T.muted, letterSpacing:'0.06em', textTransform:'uppercase', marginBottom:8 }}>
        ⚡ Efficiency · EPA per play
      </div>
      {rows.map(([lbl, epaV, succ, pct, samp]) => (
        <div key={lbl} style={{ display:'flex', alignItems:'center', gap:10, padding:'5px 0' }}>
          <span style={{ width:38, fontSize:12, fontWeight:800, color:T.muted2 }}>{lbl}</span>
          <span style={{ fontFamily:T.mono, fontSize:13.5, fontWeight:800, color:T.text, width:64 }}>
            {epaV>0?'+':''}{epaV?.toFixed(3)}</span>
          <span style={{ flex:1, height:6, background:T.card2, borderRadius:3, overflow:'hidden' }}>
            <span style={{ display:'block', height:'100%', width:`${pct??0}%`, background:pctColor(pct) }}/>
          </span>
          <span style={{ fontSize:11, fontWeight:800, color:pctColor(pct), width:34, textAlign:'right' }}>
            {pct==null?'—':`${pct}%`}</span>
          <span style={{ fontSize:10, color:T.muted, width:52, textAlign:'right' }}>{samp}</span>
        </div>
      ))}
      <div style={{ fontSize:10, color:T.muted, marginTop:6, letterSpacing:'0.03em' }}>
        EPA/play vs the league · percentile among peers{carry ? ` · ${epa.season} form` : ''} · research only
      </div>
    </div>
  )
}
// EPA percentile color — shared by the panel and the header badge.
const _epaPctColor = p => p==null ? T.muted : p>=75 ? T.green : p>=50 ? T.mint : p>=25 ? T.amber : T.red
// Pick the position-primary phase so the header badge shows the ONE efficiency
// number that defines the player (QB→pass, RB→rush, WR/TE→receiving), falling back
// to whichever phase actually has a percentile if the primary is missing.
function epaHeadline(epa, pos){
  if(!epa) return null
  const p = (pos||'').toUpperCase()
  const order = p==='QB' ? ['passing','rush','receiving']
    : p==='RB' ? ['rush','receiving','passing']
    : ['receiving','rush','passing']          // WR/TE/other
  const KEY = { passing:'epa_per_dropback', rush:'epa_per_rush', receiving:'epa_per_target' }
  const LBL = { passing:'Pass', rush:'Rush', receiving:'Rec' }
  for(const k of order){
    const ph = epa[k]
    if(ph && ph.pct != null) return { pct: ph.pct, epa: ph[KEY[k]], phase: LBL[k] }
  }
  return null
}
// Compact header chip — a player's headline EPA percentile at a glance. Ordinal
// suffix so "88th" reads like a percentile, colored by tier. Research signal only.
function EpaBadge({ epa, pos }){
  const h = epaHeadline(epa, pos)
  if(!h) return null
  const col = _epaPctColor(h.pct)
  const ord = n => { const s=['th','st','nd','rd'], v=n%100; return n+(s[(v-20)%10]||s[v]||s[0]) }
  return (
    <span title={`${h.phase} EPA/play ${h.epa>0?'+':''}${h.epa?.toFixed(3)} · ${h.pct}th percentile vs peers`}
      style={{display:'inline-flex',alignItems:'center',gap:4,fontSize:10.5,fontWeight:800,
        color:col,background:`${col}1a`,border:`1px solid ${col}55`,borderRadius:7,padding:'2px 7px',
        letterSpacing:'0.01em',whiteSpace:'nowrap'}}>
      ⚡ {ord(h.pct)} <span style={{color:T.muted,fontWeight:700}}>EPA</span>
    </span>
  )
}
// Matchup breakdown row + rank chip (shared by the PlayerModal Matchup tab).
const _mrank = r => r==null ? T.muted : r<=8 ? T.green : r<=16 ? T.mint : r<=24 ? T.amber : T.red
function MRow({ label, children }){
  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",marginBottom:8}}>
      <div style={{fontSize:10.5,color:T.muted,letterSpacing:"0.04em",marginBottom:6,textTransform:"uppercase"}}>{label}</div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>{children}</div>
    </div>
  )
}
function MChip({ v, rank }){
  return (
    <span style={{fontSize:12,fontWeight:700,color:T.text,background:T.card2,border:`1px solid ${T.border}`,borderRadius:7,padding:"5px 9px"}}>
      {v}{rank!=null && <span style={{color:_mrank(rank),fontSize:10,marginLeft:5}}>#{rank}</span>}
    </span>
  )
}
// Two-up historical split (e.g. vs Zone | vs Man); greens the value above his season avg.
function SplitPair({ la, a, lb, b, avg }){
  const cell = (lab,d)=> (
    <div style={{flex:1}}>
      <div style={{fontSize:10.5,color:T.muted}}>{lab}</div>
      {d ? <div style={{fontFamily:T.mono,fontWeight:800,fontSize:13,color:avg!=null&&d.avg>=avg?T.green:T.text}}>
        {d.avg}<span style={{fontSize:10,color:T.muted,fontWeight:400}}> ({d.games})</span></div>
        : <div style={{fontSize:13,color:T.faint}}>—</div>}
    </div>
  )
  return <div style={{display:"flex",gap:10,marginBottom:7}}>{cell(la,a)}{cell(lb,b)}</div>
}

// Where the defense is soft by depth — slot vs deep rec-yds allowed vs the league
// average. The "catches not yards" read: an off/zone defense concedes underneath but
// can wall the deep shots, so volume comes without a yardage ceiling. (mu.def_depth)
function DefDepth({ dd, opp }){
  const bar = (lab, v, lg) => {
    if(v==null||lg==null) return null
    const diff = v - lg
    const col = diff>2?T.green : diff<-8?T.red : T.amber
    const tag = diff>2?'soft' : diff<-8?'wall' : 'avg'
    const w = Math.max(6, Math.min(100, v/Math.max(lg,v)*100))
    return (
      <div style={{display:'flex',alignItems:'center',gap:8,marginTop:6}}>
        <div style={{width:60,fontSize:11,color:T.muted}}>{lab}</div>
        <div style={{flex:1,height:8,background:T.card2,borderRadius:5,overflow:'hidden'}}>
          <div style={{width:`${w}%`,height:'100%',background:col}}/></div>
        <div style={{fontFamily:T.mono,fontSize:12,fontWeight:800,color:T.text,width:30,textAlign:'right'}}>{Math.round(v)}</div>
        <div style={{fontSize:10,color:T.faint,width:38}}>lg {Math.round(lg)}</div>
        <div style={{fontSize:10,fontWeight:800,color:col,width:28,textAlign:'right'}}>{tag}</div>
      </div>
    )
  }
  const deepWall = dd.deep_yds!=null && dd.lg_deep_yds!=null && (dd.deep_yds - dd.lg_deep_yds) < -8
  const slotSoft = dd.slot_yds!=null && dd.lg_slot_yds!=null && (dd.slot_yds - dd.lg_slot_yds) > -2
  if(dd.slot_yds==null && dd.deep_yds==null) return null
  return (
    <MRow label={`Where ${opp ? `the ${teamNick(opp)}` : 'the defense'} ${opp ? 'are' : 'is'} soft`}>
      <div style={{width:'100%'}}>
        {bar('Slot', dd.slot_yds, dd.lg_slot_yds)}
        {bar('Deep', dd.deep_yds, dd.lg_deep_yds)}
        {deepWall && slotSoft && (
          <div style={{fontSize:11,color:T.text,marginTop:8,lineHeight:1.45}}>
            Soft underneath, <b style={{color:T.red}}>deep wall</b> — concedes catches, not yards.
          </div>
        )}
      </div>
    </MRow>
  )
}

// Coverage IQ — how he produces vs ZONE and MAN (per route, ranked among his position), how often
// he's the QB's first read, and what coverage this opponent plays, with a one-line fit. Free
// nflverse charting: zone/man + coverage mix are completed seasons (2026 charting is post-season);
// first-read share is this season. Self-fetching so it never slows the rest of the tab.
const _ordN = n => n==null ? '' : `${n}${(n%100>=11&&n%100<=13)?'th':({1:'st',2:'nd',3:'rd'}[n%10]||'th')}`
function CoverageIQ({ gsis, opp, season }){
  const [d,setD] = useState(null)
  useEffect(()=>{ let a=true; setD(null)
    getNFLCoverageProfile(gsis, opp, season).then(r=>{ if(a) setD(r||{}) }).catch(()=>{ if(a) setD({}) })
    return ()=>{ a=false } },[gsis, opp, season])
  if(!d) return null
  const splits = d.splits||[], fr = d.first_read, df = d.defense, fit = d.fit
  if(!splits.length && !fr && !df) return null
  const rankCol = (r, of) => r==null||!of ? T.muted : r/of<=0.33 ? T.green : r/of>0.67 ? T.red : T.amber
  const cell = (v, r, of, fmt) => (
    <div style={{textAlign:'right'}}>
      <div style={{fontFamily:T.mono,fontSize:14,fontWeight:900,color:T.text}}>{v==null?'—':fmt(v)}</div>
      <div style={{fontSize:10,color:rankCol(r,of),fontWeight:700}}>{r!=null?`${_ordN(r)} of ${of}`:'small sample'}</div>
    </div>
  )
  const fitCol = fit?.level==='good'?T.green : fit?.level==='tough'?T.red : T.muted2
  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,padding:'10px 12px',marginBottom:8}}>
      <div style={{display:'flex',alignItems:'baseline',justifyContent:'space-between',marginBottom:6}}>
        <span style={{fontSize:10.5,color:T.muted,letterSpacing:'0.04em',textTransform:'uppercase'}}>Coverage IQ · zone vs man</span>
        {fr && <span style={{fontSize:10.5,color:T.muted}}>1st read <b style={{color:T.text,fontFamily:T.mono}}>{Math.round(fr.share*100)}%</b>
          {fr.rank!=null && <span style={{color:rankCol(fr.rank,fr.of)}}> · {_ordN(fr.rank)}</span>}</span>}
      </div>
      {fit && <div style={{fontSize:12,color:T.text,lineHeight:1.45,marginBottom:8,borderLeft:`3px solid ${fitCol}`,paddingLeft:8}}>
        {fit.level!=='neutral' && <b style={{color:fitCol}}>{fit.level==='good'?'Good coverage fit. ':'Tough coverage fit. '}</b>}{fit.text}</div>}
      {splits.length>0 && (
        <div style={{overflowX:'auto'}}>
          <div style={{display:'grid',gridTemplateColumns:'1fr 74px 74px',gap:'4px 10px',alignItems:'center',minWidth:260}}>
            <span style={{fontSize:10,color:T.faint,fontWeight:800,letterSpacing:'0.06em'}}>VS</span>
            <span style={{fontSize:10,color:T.faint,fontWeight:800,letterSpacing:'0.06em',textAlign:'right'}}>YDS / ROUTE</span>
            <span style={{fontSize:10,color:T.faint,fontWeight:800,letterSpacing:'0.06em',textAlign:'right'}}>TGT / ROUTE</span>
            {splits.map(b => ['zone','man'].map(cov => {
              const c = b[cov]; if(!c) return null
              return <React.Fragment key={`${b.season}${cov}`}>
                <span style={{fontSize:12.5,fontWeight:800,color:T.text}}>
                  <span style={{display:'inline-block',width:8,height:8,borderRadius:2,marginRight:6,background:cov==='zone'?T.mint:'#8B5CF6'}}/>
                  {cov==='zone'?'Zone':'Man'} <span style={{fontSize:10.5,color:T.faint,fontWeight:700}}>{b.season} · {c.routes} rts</span></span>
                {cell(c.yprr, c.yprr_rank, c.of, v=>v.toFixed(2))}
                {cell(c.tprr, c.tprr_rank, c.of, v=>v.toFixed(2))}
              </React.Fragment>
            }))}
          </div>
        </div>
      )}
      {df && (
        <div style={{marginTop:10,paddingTop:8,borderTop:`1px solid ${T.border}`}}>
          <div style={{fontSize:11.5,color:T.muted2,marginBottom:6}}>
            <b style={{color:T.text}}>{df.team}</b> played zone <b style={{color:T.text,fontFamily:T.mono}}>{Math.round(df.zone_rate*100)}%</b>
            {df.zone_rank!=null && <span> ({_ordN(df.zone_rank)} most of {df.of})</span>} · {df.season}
          </div>
          {df.covers.slice(0,4).map(c => (
            <div key={c.key} style={{display:'flex',alignItems:'center',gap:8,marginTop:4}}>
              <span style={{width:56,fontSize:11,color:T.muted}}>{c.label}</span>
              <div style={{flex:1,height:7,background:T.card2,borderRadius:4,overflow:'hidden'}}>
                <div style={{width:`${Math.min(100,c.rate/0.45*100)}%`,height:'100%',background:T.blue}}/></div>
              <span style={{width:38,textAlign:'right',fontFamily:T.mono,fontSize:11.5,fontWeight:800,color:T.text}}>{Math.round(c.rate*100)}%</span>
              <span style={{width:34,textAlign:'right',fontSize:10,color:T.faint}}>{_ordN(c.rank)}</span>
            </div>
          ))}
        </div>
      )}
      <div style={{fontSize:10,color:T.faint,marginTop:8,lineHeight:1.45}}>
        Ranks are among {splits[0]?.zone?.position||splits[0]?.man?.position||'his position'}s{fr ? `; 1st-read share is ${fr.season} through week ${fr.through_week}` : ''}. Zone/man and coverage mix are from completed seasons (this season's coverage charting isn't public until it ends). Routes = pass plays he was on the field for.
      </div>
    </div>
  )
}

// ── Side-by-side Matchup Breakdown ───────────────────────────────────────────
// A head-to-head: HIM (his profile) vs OPP D (what the defense concedes), paired
// facet by facet with a center edge bar that leans green when the matchup favors
// the bet. This is the NFL answer to the baseball "Matchup Breakdown" drill-down.
const _clampN = (v,lo,hi)=>Math.max(lo,Math.min(hi,v))
const _rankEdge = r => r==null ? 0 : _clampN((16.5-r)/16, -1, 1)   // 1 soft=+, 32 tough=−

function buildFacets(e, mu){
  const pos = (e.pos||'WR').toUpperCase()
  const isTD = e.market==='Anytime TD'
  const v = mu.volume||{}, ng = mu.ngs||{}, rz = mu.redzone||{}, rush = mu.rushing||{}
  const pass = mu.passing||{}, sc = mu.scheme, dd = mu.def_depth, def = mu.defense||{}
  const rank = isTD ? def.td_rank : def.yds_rank
  const F = []
  const push = (o)=>{ if(o) F.push(o) }

  // Headline: defense vs his position (rank drives the edge)
  if(rank!=null) push({ label:`${teamNick(e.opp)} defense vs ${pos}`,
    pv: def.yds!=null ? `${def.yds}` : '—', psub: isTD ? 'his market' : 'yds/g allowed',
    dv: `#${rank}`, dsub: rank<=10?'soft — attack':rank>=23?'tough':'middling',
    edge: _rankEdge(rank) })

  if(pos==='WR'||pos==='TE'){
    if(v.targets_pg!=null) push({ label:'Target volume',
      pv:`${v.targets_pg}`, psub:'targets/g', dv: mu.pace!=null?`${Math.round(mu.pace)}`:'—', dsub:'opp plays/g',
      edge:_clampN((v.targets_pg-6)/4,-1,1) })
    if(dd) push({ label:'Where he works vs what they allow',
      pv: mu.alignment?.label || (ng.role?ng.role.split('—')[0].trim():'—'),
      psub: mu.alignment?`${Math.round((mu.alignment.slot_pct||0)*100)}% slot`:'his role',
      dv:`${Math.round(dd.slot_yds)} slot · ${Math.round(dd.deep_yds)} deep`, dsub:'rec yds/g allowed',
      edge: dd.lg_slot_yds? _clampN(((mu.alignment?.slot_pct>=0.55? dd.slot_yds-dd.lg_slot_yds : dd.deep_yds-(dd.lg_deep_yds||dd.deep_yds)))/25,-1,1) : 0 })
    if(ng.separation!=null||sc) push({ label:'Separation vs coverage',
      pv: ng.separation!=null?`${ng.separation}`:'—', psub:'yd separation',
      dv: sc?.label||'—', dsub: sc?`${Math.round((sc.zone_rate||0)*100)}% zone`:'scheme',
      edge:_clampN(((ng.separation!=null?(ng.separation-2.7)/1.2:0) + (sc&&sc.label==='Zone-heavy'?0.3:0)),-1,1) })
  } else if(pos==='RB'){
    if(v.carries_pg!=null) push({ label:'Carry volume',
      pv:`${v.carries_pg}`, psub:'carries/g', dv: mu.pace!=null?`${Math.round(mu.pace)}`:'—', dsub:'opp plays/g',
      edge:_clampN((v.carries_pg-12)/6,-1,1) })
    if(rush.box_stacked_rate!=null) push({ label:'Run game — box count',
      pv:`${Math.round(rush.box_stacked_rate)}%`, psub:'stacked box faced',
      dv: def.yds!=null?`${def.yds}`:'—', dsub:'rush yds/g allowed',
      edge:_clampN(((25-rush.box_stacked_rate)/8 + _rankEdge(def.yds_rank))/2,-1,1) })
  } else if(pos==='QB'){
    if(v.pass_att_pg!=null) push({ label:'Pass volume',
      pv:`${v.pass_att_pg}`, psub:'attempts/g', dv: mu.pace!=null?`${Math.round(mu.pace)}`:'—', dsub:'opp plays/g',
      edge:_clampN((v.pass_att_pg-33)/6,-1,1) })
    if(pass.cpoe!=null||mu.pressure!=null) push({ label:'Accuracy vs pass rush',
      pv: pass.cpoe!=null?`${pass.cpoe>0?'+':''}${pass.cpoe}%`:'—', psub:'CPOE',
      dv: mu.pressure!=null?`${Math.round(mu.pressure*100)}%`:'—', dsub:'pressure rate',
      edge:_clampN(((pass.cpoe!=null?pass.cpoe/3:0) - (mu.pressure!=null?(mu.pressure-0.22)/0.12:0)),-1,1) })
  }

  // Red zone — the scoring facet (all positions, esp. TD bets)
  if(rz.player_rz_share!=null || rz.def_rz_td_rate!=null){
    const glc = (pos==='RB'||pos==='QB')?rz.gl_carries:rz.gl_targets   // QB scores on carries
    push({ label:'Red zone & goal line',
      pv: rz.player_rz_share!=null?`${Math.round(rz.player_rz_share*100)}%`:'—',
      psub: glc!=null?`RZ share · ${glc} goal-line`:'RZ touch share',
      dv: rz.def_rz_td_rate!=null?`${Math.round(rz.def_rz_td_rate*100)}%`:'—', dsub:'RZ TD rate allowed',
      edge:_clampN(((rz.player_rz_share!=null?(rz.player_rz_share-0.15)/0.2:0) + (glc?_clampN(glc/6,0,1):0))/1.5,-1,1) })
  }
  return F
}

// Long values (a role like "Pressed at the line", "61 slot · 109 deep") wrap onto a second
// line at a smaller size instead of being cut off with an ellipsis.
const _valStyle = v => ({ fontSize: String(v||'').length > 9 ? 12.5 : 14, fontWeight:800, color:T.text,
  fontFamily:T.mono, lineHeight:1.25, overflowWrap:'anywhere' })

function EdgeRow({ f }){
  const col = f.edge>=0.33?T.green : f.edge<=-0.33?T.red : T.amber
  const w = Math.min(48, Math.abs(f.edge)*48)
  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:11,padding:'9px 12px',marginBottom:7}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'baseline',marginBottom:7}}>
        <span style={{fontSize:10,color:T.muted,textTransform:'uppercase',letterSpacing:'0.05em'}}>{f.label}</span>
        <span style={{fontSize:10,fontWeight:800,color:col}}>{f.edge>=0.33?'EDGE':f.edge<=-0.33?'AGAINST':'EVEN'}</span>
      </div>
      <div style={{display:'flex',alignItems:'center',gap:10}}>
        <div style={{flex:1,minWidth:0}}>
          <div style={_valStyle(f.pv)}>{f.pv}</div>
          {f.psub && <div style={{fontSize:10,color:T.muted}}>{f.psub}</div>}
        </div>
        <div style={{width:48,flexShrink:0}}>
          <div style={{height:6,background:T.card2,borderRadius:3,position:'relative',overflow:'hidden'}}>
            <div style={{position:'absolute',left:'50%',top:0,bottom:0,width:1,background:T.border2}}/>
            <div style={{position:'absolute',top:0,bottom:0,left:f.edge>=0?'50%':`${50-w}%`,width:`${w}%`,background:col,borderRadius:2}}/>
          </div>
        </div>
        <div style={{flex:1,minWidth:0,textAlign:'right'}}>
          <div style={_valStyle(f.dv)}>{f.dv}</div>
          {f.dsub && <div style={{fontSize:10,color:T.muted}}>{f.dsub}</div>}
        </div>
      </div>
    </div>
  )
}

export function MatchupBreakdown({ e, mu, onDefense }){
  const facets = buildFacets(e, mu)
  if(!facets.length) return null
  const score = facets.reduce((s,f)=>s+f.edge,0)/facets.length
  const tone = score>=0.2?T.green : score<=-0.2?T.red : T.amber
  const verdict = score>=0.35?'Plus matchup' : score>=0.15?'Leans his way' : score<=-0.2?'Tough draw' : 'Even matchup'
  return (
    <div style={{marginBottom:14}}>
      {/* header: HIM vs OPP D + overall lean */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
        <div style={{display:'flex',gap:10}}>
          <span style={{fontSize:11,fontWeight:800,color:T.text}}>{(e.full_name||e.name||'Him').split(' ').slice(-1)[0]}</span>
          <span style={{fontSize:11,color:T.faint}}>vs</span>
          <span style={{fontSize:11,fontWeight:800,color:T.muted}}><TeamTag abbr={e.opp} size={14}/> defense</span>
        </div>
        <span style={{fontSize:11,fontWeight:800,color:tone}}>{verdict}</span>
      </div>
      <div style={{display:'flex',justifyContent:'space-between',fontSize:10,color:T.faint,letterSpacing:'0.08em',padding:'0 2px 6px'}}>
        <span>HIM</span><span>OPP DEFENSE</span>
      </div>
      {facets.map((f,i)=><EdgeRow key={i} f={f}/>)}
      {onDefense && e.opp && (
        <button onClick={()=>onDefense(e.opp, e.pos)} style={{width:'100%',marginTop:2,padding:'10px 0',
          background:T.card2,border:`1px solid ${T.border}`,borderRadius:10,color:T.green,fontWeight:800,
          fontSize:12.5,cursor:'pointer'}}>
          {teamNick(e.opp)} defense — full breakdown →
        </button>
      )}
    </div>
  )
}

// Bet-impact waterfall — baseline hit% → each factor's ± probability-point
// contribution → the model's hit% and edge vs the book. One currency: pp toward hitting.
function BetImpact({ impact, edge, bet }){
  const bar = pp => {
    const w = Math.min(48, Math.abs(pp) * 4)
    return (
      <div style={{height:6,background:T.card2,borderRadius:3,position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",left:"50%",top:0,bottom:0,width:1,background:T.border2}}/>
        <div style={{position:"absolute",top:0,bottom:0,left:pp>=0?"50%":`${50-w}%`,width:`${w}%`,
          background:pp>=0?T.green:T.amber,borderRadius:2}}/>
      </div>
    )
  }
  return (
    <div style={{marginBottom:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",marginBottom:2}}>
        <span style={{fontSize:10.5,color:T.muted,textTransform:"uppercase",letterSpacing:"0.05em"}}>Chance of hitting</span>
        <span style={{fontFamily:T.mono,fontWeight:900,fontSize:19,color:probColor((impact.model_pct||0)/100)}}>{impact.model_pct}%</span>
      </div>
      <div style={{fontSize:11,color:T.muted,marginBottom:10}}>{bet}</div>

      <div style={{display:"flex",justifyContent:"space-between",fontSize:11.5,color:T.muted,marginBottom:8}}>
        <span>Baseline · neutral matchup</span><span style={{fontFamily:T.mono}}>{impact.base_pct}%</span>
      </div>
      {impact.factors.map((f,i)=>(
        <div key={i} style={{marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:3}}>
            <span style={{color:T.text}}>{f.name}</span>
            <span style={{fontFamily:T.mono,fontWeight:700,color:f.pp>=0?T.green:f.pp<0?T.red:T.muted}}>{f.pp>=0?'+':''}{f.pp}%</span>
          </div>
          {bar(f.pp)}
        </div>
      ))}
      {edge!=null && Math.abs(edge)>=0.5 && (
        <div style={{display:"flex",justifyContent:"space-between",fontSize:12.5,marginTop:10,paddingTop:9,borderTop:`1px solid ${T.border}`}}>
          <span style={{color:T.text,fontWeight:700}}>Edge vs book</span>
          <span style={{fontFamily:T.mono,fontWeight:800,color:edge>=0?T.green:T.red}}>{edge>=0?'+':''}{edge.toFixed(1)}%</span>
        </div>
      )}
    </div>
  )
}

// The Case — the scannable green-check verdict panel, mirroring the baseball side.
// Each factor is a ✓ (good) / ✕ (concern) / • (neutral) with a plain-English reason.
function TheCase({ tc }){
  if(!tc || !tc.factors?.length) return null
  const vNeg = /no price edge|priced|tough|mixed|under|coin/i.test(tc.verdict||'')
  const vTone = vNeg ? T.muted : tc.greens>=4 && tc.reds<=1 ? T.green : tc.greens>tc.reds ? T.mint : T.muted
  const toneColor = t => t==='good'?T.green : t==='bad'?T.red : T.muted
  const toneBg = t => t==='good'?T.greenDim : t==='bad'?'rgba(239,106,106,0.10)' : T.card2
  const toneMark = t => t==='good'?'✓' : t==='bad'?'✕' : '•'
  return (
    <div style={{background:T.card,border:`1px solid ${vTone}`,borderRadius:14,padding:'12px 13px',marginBottom:14}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:9}}>
        <div style={{fontSize:13,fontWeight:900,letterSpacing:'-0.01em',color:T.text}}>The Case
          {tc.market ? <span style={{color:T.muted,fontWeight:700,fontSize:11}}> · {tc.market}</span> : null}</div>
        <div style={{fontSize:11.5,fontWeight:800,color:vTone}}>{tc.verdict}</div>
      </div>
      <div style={{display:'flex',gap:6,marginBottom:10}}>
        <span style={{fontSize:10,fontWeight:700,color:T.green,background:T.greenDim,border:`1px solid ${T.green}`,borderRadius:6,padding:'2px 8px'}}>{tc.greens} green</span>
        {tc.reds>0 && <span style={{fontSize:10,fontWeight:700,color:T.red,background:'rgba(239,106,106,0.10)',border:'1px solid rgba(239,106,106,0.30)',borderRadius:6,padding:'2px 8px'}}>{tc.reds} concern</span>}
      </div>
      {tc.factors.map((f,i)=>(
        <div key={i} style={{display:'flex',gap:9,alignItems:'flex-start',padding:'6px 0',borderTop:i?`1px solid ${T.border}`:'none'}}>
          <span style={{flexShrink:0,width:18,height:18,marginTop:1,borderRadius:5,background:toneBg(f.tone),color:toneColor(f.tone),fontSize:11,fontWeight:900,display:'flex',alignItems:'center',justifyContent:'center'}}>{toneMark(f.tone)}</span>
          <div style={{minWidth:0}}>
            <div style={{fontSize:12.5,fontWeight:700,color:toneColor(f.tone)}}>{f.label}</div>
            <div style={{fontSize:11.5,color:T.muted,lineHeight:1.4}}>{f.detail}</div>
          </div>
        </div>
      ))}
      <div style={{fontSize:10,color:T.faint,marginTop:8}}>Information only — not betting advice. 21+.</div>
    </div>
  )
}

// Fold the model's OWN factors (the bet-impact waterfall: game script, rest/home,
// weather) into The Case, so the panel is substantive even when live matchup data
// (red-zone role, Next Gen, etc.) hasn't loaded. These three never appear in the
// backend case, so there's nothing to de-dupe. Recomputes the tally + verdict, with
// the same negative-edge value gate the backend uses.
function mergeCase(base, e){
  const factors = base?.factors ? base.factors.slice() : []
  const ADD = [['Game script','Game script'], ['Rest / home','Rest & schedule'], ['Weather','Weather']]
  const byName = Object.fromEntries((e.impact?.factors||[]).map(f=>[f.name, f]))
  for(const [name,label] of ADD){
    const f = byName[name]
    if(!f || Math.abs(f.pp) < 0.3) continue
    factors.push({ tone: f.pp>=0.5?'good':f.pp<=-0.5?'bad':'neutral', label,
      detail: `${f.pp>=0?'+':''}${f.pp}% to hitting` })
  }
  if(!factors.length) return null
  const greens = factors.filter(f=>f.tone==='good').length
  const reds = factors.filter(f=>f.tone==='bad').length
  let verdict = greens>=4&&reds<=1 ? 'Strong case' : greens>reds ? 'Leans yes'
    : greens===reds ? 'Mixed' : 'Tough spot'
  if(e.edge_pct!=null && e.edge_pct<=-1.5 && (verdict==='Strong case'||verdict==='Leans yes'))
    verdict = 'No price edge'
  return { market: base?.market || e.market, verdict, greens, reds, factors }
}

// ── Defense Intel drill-down — the NFL answer to "Pitcher Intel" ─────────────
const _rkchip = r => r==null ? null :
  <span style={{color:_mrank(r),fontSize:10,fontWeight:800,marginLeft:5}}>#{r}</span>

export function DefenseModal({ opp, pos, season, week, onClose }){
  const [d,setD] = useState(undefined)
  useEffect(()=>{ let live=true
    getNFLDefense(season, week).then(r=>{ if(live) setD((r.rows||[]).find(t=>t.team===opp) || null) })
    return ()=>{ live=false }
  },[opp,season,week])
  const ROWS = [
    { k:'QB', y:'qb', yr:'qbr', t:'qb_td', tr:'qbtr', yl:'Pass yds/g' },
    { k:'RB', y:'rb', yr:'rbr', t:'rb_td', tr:'rbtr', yl:'Rush yds/g' },
    { k:'WR', y:'wr', yr:'wrr', t:'wr_td', tr:'wrtr', yl:'Rec yds/g' },
    { k:'TE', y:'te', yr:'ter', t:'te_td', tr:'tetr', yl:'Rec yds/g' },
  ]
  const want = (pos||'').toUpperCase()
  return (
    <Sheet onClose={onClose}>
      <div style={{padding:'8px 16px 24px'}}>
        <div style={{fontSize:20,fontWeight:900,marginTop:6}}><TeamTag abbr={opp} size={28}/> defense</div>
        <div style={{fontSize:12,color:T.muted,marginBottom:14}}>What they give up · <b style={{color:T.green}}>#1 = softest</b> (allows the most)</div>
        {d===undefined ? <div style={{fontSize:12,color:T.muted,padding:'16px 0'}}>Loading defense…</div>
          : !d ? <div style={{fontSize:12,color:T.muted,padding:'16px 0'}}>Defense data unavailable right now.</div> : (
          <div>
            {ROWS.map(r=>{
              const hi = r.k===want
              return (
                <div key={r.k} style={{background:hi?T.greenDim:T.card,border:`1px solid ${hi?T.green:T.border}`,
                  borderRadius:11,padding:'11px 13px',marginBottom:8}}>
                  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <span style={{fontSize:14,fontWeight:800,color:T.text}}>vs {r.k}{hi && <span style={{fontSize:10,color:T.green,marginLeft:6}}>his matchup</span>}</span>
                    <div style={{display:'flex',gap:16,fontFamily:T.mono}}>
                      <span style={{fontSize:13,fontWeight:800,color:T.text}}>{d[r.y]??'—'}{_rkchip(d[r.yr])}
                        <span style={{fontSize:10,color:T.muted,fontWeight:400,marginLeft:3}}>yds</span></span>
                      <span style={{fontSize:13,fontWeight:800,color:T.text}}>{d[r.t]??'—'}{_rkchip(d[r.tr])}
                        <span style={{fontSize:10,color:T.muted,fontWeight:400,marginLeft:3}}>TD</span></span>
                    </div>
                  </div>
                  {/* WR slot-vs-outside split — where they bleed */}
                  {r.k==='WR' && (d.wr_slot!=null||d.wr_deep!=null) && (
                    <div style={{display:'flex',gap:16,marginTop:8,paddingTop:8,borderTop:`1px solid ${T.border}`,fontFamily:T.mono}}>
                      <span style={{fontSize:12,color:T.muted}}>Slot <b style={{color:T.text}}>{d.wr_slot??'—'}</b>{_rkchip(d.wr_slot_r)}</span>
                      <span style={{fontSize:12,color:T.muted}}>Outside <b style={{color:T.text}}>{d.wr_deep??'—'}</b>{_rkchip(d.wr_deep_r)}</span>
                    </div>
                  )}
                </div>
              )
            })}
            {/* Red-zone TD rate allowed */}
            {d.rz_td_rate!=null && (
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',background:T.card,
                border:`1px solid ${T.border}`,borderRadius:11,padding:'11px 13px',marginTop:2}}>
                <span style={{fontSize:13,fontWeight:800,color:T.text}}>Red-zone TD rate allowed</span>
                <span style={{fontFamily:T.mono,fontSize:14,fontWeight:800,color:_mrank(d.rzr)}}>{Math.round(d.rz_td_rate*100)}%{_rkchip(d.rzr)}</span>
              </div>
            )}
            {/* EPA allowed per play — the efficiency read (modern DVOA-equivalent) on the
                defense, mirroring the player-side Efficiency panel. Higher = allows more
                expected points = softer to attack, so #1 rank is greened like the rest. */}
            {(d.def_rush_epa!=null || d.def_pass_epa!=null) && (
              <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:11,padding:'11px 13px',marginTop:8}}>
                <div style={{fontSize:10.5,color:T.muted,letterSpacing:'0.06em',textTransform:'uppercase',marginBottom:8}}>
                  ⚡ EPA allowed per play</div>
                {[['Rush','def_rush_epa','def_rush_epa_r'],['Pass','def_pass_epa','def_pass_epa_r']].map(([lbl,vk,rk])=>
                  d[vk]!=null && (
                    <div key={lbl} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'4px 0'}}>
                      <span style={{fontSize:12.5,fontWeight:700,color:T.text}}>{lbl}</span>
                      <span style={{fontFamily:T.mono,fontSize:13.5,fontWeight:800,color:_mrank(d[rk])}}>
                        {d[vk]>0?'+':''}{d[vk].toFixed(3)}{_rkchip(d[rk])}</span>
                    </div>
                  ))}
              </div>
            )}
            <div style={{fontSize:10,color:T.faint,marginTop:10,lineHeight:1.5}}>
              Ranks are league-wide, 1 = allows the most (softest to attack). EPA allowed = expected points the defense gives up per play (higher = softer). WR slot/outside is a target-depth split (≤8 air yds = slot). Carried over from last season until {season} games bank.
            </div>
          </div>
        )}
      </div>
    </Sheet>
  )
}

// ── Usage & Alignment panel — the player-centric half of the dashboard ───────
// Pulls "who is this player / how is he used" out of the matchup-dense tab into a clean,
// PropFinder-style profile: where he lines up (real PFF slot/wide/inline when loaded, else
// the honest Next Gen cushion proxy), his recent workload & role, how he wins, and his
// red-zone role. Consumes the SAME `mu` the Matchup tab already fetched — no extra call.
function AlignBar({ wide, slot, inline }){
  const segs = [["Wide", wide, T.blue], ["Slot", slot, T.green], ["Inline", inline, T.purple]]
    .filter(([, v]) => v != null && v > 0)
  return (
    <div>
      <div style={{display:"flex",height:14,borderRadius:7,overflow:"hidden",border:`1px solid ${T.border}`}}>
        {segs.map(([lab, v, c]) => <div key={lab} title={`${lab} ${Math.round(v*100)}%`}
          style={{width:`${v*100}%`,background:c}}/>)}
      </div>
      <div style={{display:"flex",gap:12,marginTop:7,flexWrap:"wrap"}}>
        {segs.map(([lab, v, c]) => (
          <span key={lab} style={{fontSize:11,color:T.muted,fontFamily:T.mono}}>
            <span style={{display:"inline-block",width:8,height:8,borderRadius:2,background:c,marginRight:5}}/>
            {lab} <b style={{color:T.text}}>{Math.round(v*100)}%</b>
          </span>
        ))}
      </div>
    </div>
  )
}

function UStat({ label, value, sub }){
  return (
    <div style={{flex:1,minWidth:86,background:T.card,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 11px"}}>
      <div style={{fontSize:10,color:T.muted,textTransform:"uppercase",letterSpacing:"0.04em"}}>{label}</div>
      <div style={{fontFamily:T.mono,fontWeight:800,fontSize:15,color:T.text,marginTop:3}}>{value}</div>
      {sub && <div style={{fontSize:10,color:T.faint,marginTop:1}}>{sub}</div>}
    </div>
  )
}

function UsagePanel({ e, mu }){
  const pos = (e.pos||'').toUpperCase()
  if(!e.opp)
    return <div style={{fontSize:12,color:T.muted,lineHeight:1.5,padding:"8px 0"}}>Open this player from the board (Home or Bets) to see his usage profile.</div>
  if(mu===undefined) return <div style={{fontSize:12,color:T.muted,padding:"16px 0"}}>Loading usage…</div>
  if(!mu) return <div style={{fontSize:12,color:T.muted,padding:"16px 0"}}>Usage data unavailable right now.</div>

  const al = mu.alignment, ng = mu.ngs, v = mu.volume, rz = mu.redzone, ru = mu.rushing, pa = mu.passing
  const pctI = x => x==null ? '—' : `${Math.round(x*100)}%`
  const anyWin = ng && (ng.separation!=null||ng.cushion!=null||ng.yac!=null||ng.catch_pct!=null)
  return (
    <div>
      {/* Where he lines up — real PFF alignment, else the Next Gen cushion read. */}
      <div style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Where he lines up</div>
      {al ? (
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px",marginBottom:12}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
            <b style={{fontSize:14,color:T.text}}>{al.label}</b>
            <span style={{fontSize:10,fontWeight:800,color:T.green,background:T.greenDim,border:`1px solid ${T.green}55`,borderRadius:6,padding:"2px 7px"}}>PFF</span>
          </div>
          <AlignBar wide={al.wide_pct} slot={al.slot_pct} inline={al.inline_pct}/>
        </div>
      ) : (pos==='WR'||pos==='TE') ? (
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px",marginBottom:12}}>
          {ng?.role ? <div style={{fontSize:13,color:T.text,fontWeight:700}}>{ng.role}</div>
            : <div style={{fontSize:12.5,color:T.muted}}>Where he lines up isn’t available yet for this player.</div>}
          {ng?.cushion!=null && <div style={{fontSize:11,color:T.muted,fontFamily:T.mono,marginTop:4}}>{ng.cushion} yd cushion · {ng.separation!=null?`${ng.separation} yd separation`:''}</div>}
        </div>
      ) : null}

      {/* Role & workload — recent touches + red-zone role. */}
      {(v || (rz && (rz.player_rz_share!=null||rz.gl_carries||rz.gl_targets))) && (<>
        <div style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>Role &amp; workload <span style={{color:T.faint}}>· recent / game</span></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
          {v?.pass_att_pg!=null && <UStat label="Attempts" value={v.pass_att_pg} sub={v.ypa!=null?`${v.ypa} YPA`:null}/>}
          {v?.carries_pg!=null && <UStat label="Carries" value={v.carries_pg}/>}
          {v?.targets_pg!=null && <UStat label="Targets" value={v.targets_pg} sub={v.catch_rate!=null?`${pctI(v.catch_rate)} caught`:null}/>}
          {v?.rec_pg!=null && pos!=='RB' && <UStat label="Catches" value={v.rec_pg} sub={v.rec_yds_pg!=null?`${v.rec_yds_pg} yds`:null}/>}
          {rz?.player_rz_share!=null && <UStat label="RZ share" value={pctI(rz.player_rz_share)} sub="of team RZ touches"/>}
          {(pos==='RB'||pos==='QB') ? (rz?.gl_carries!=null && <UStat label="Goal line" value={rz.gl_carries} sub="carries inside 5"/>)
            : (rz?.gl_targets!=null && <UStat label="Goal line" value={rz.gl_targets} sub="targets inside 5"/>)}
        </div>
      </>)}

      {/* How he wins — the efficiency signals, position-aware. */}
      {(anyWin || pa || (ru && (ru.ryoe_per_att!=null||ru.rush_efficiency!=null||ru.box_stacked_rate!=null))) && (<>
        <div style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8}}>How he wins <span style={{color:T.faint}}>· Next Gen</span></div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
          {anyWin && <>
            {ng.separation!=null && <UStat label="Separation" value={`${ng.separation} yd`}/>}
            {ng.yac!=null && <UStat label="YAC" value={ng.yac}/>}
            {ng.catch_pct!=null && <UStat label="Catch %" value={`${ng.catch_pct}%`}/>}
          </>}
          {pa && <>
            {pa.cpoe!=null && <UStat label="CPOE" value={`${pa.cpoe>0?'+':''}${pa.cpoe}%`} sub="vs expected"/>}
            {pa.adot!=null && <UStat label="aDOT" value={pa.adot} sub="avg depth"/>}
            {pa.time_to_throw!=null && <UStat label="Time to throw" value={`${pa.time_to_throw}s`}/>}
          </>}
          {ru && <>
            {ru.ryoe_per_att!=null && <UStat label="RYOE/att" value={`${ru.ryoe_per_att>0?'+':''}${ru.ryoe_per_att}`} sub="over expected"/>}
            {ru.box_stacked_rate!=null && <UStat label="Stacked box" value={`${Math.round(ru.box_stacked_rate)}%`} sub="8+ in box"/>}
            {ru.ol_run_block_grade!=null && <UStat label="OL run block" value={ru.ol_run_block_grade} sub="PFF grade"/>}
          </>}
        </div>
      </>)}

      {(() => {
        // Carryover note fires on ANY shown block's source season, not just receiving NGS —
        // so a RB/QB whose workload is last season's is flagged even when the NGS block is absent.
        const src = [v, ng, ru, pa, al].map(b => b && b.source_season).find(s => s && s !== 2026)
        return (
          <div style={{fontSize:10,color:T.faint,marginTop:6,lineHeight:1.5}}>
            His own profile — where he aligns, how he's used, and how he wins — independent of this week's opponent.
            {src ? ` Reflects ${src} play; sharpens as 2026 games bank.` : ''} Informational only · 21+.
          </div>
        )
      })()}
    </div>
  )
}

// Yards + TD builder — drag the yards line, watch the CORRELATED joint P(over AND scores)
// update live. Fetches the whole curve once (one call) so the slider is instant; the joint
// is the copula number (not the naive multiply), with the marginals and a plain read.
const COMBO_MK = { WR: [['rec_yards', 'Rec yds']], TE: [['rec_yards', 'Rec yds']],
  QB: [['pass_yards', 'Pass yds']],
  RB: [['rush_yards', 'Rush yds'], ['rec_yards', 'Rec yds']] }

function ComboBuilder({ e, season, week }){
  const pos = (e.pos || '').toUpperCase()
  const markets = COMBO_MK[pos] || [['rec_yards', 'Rec yds']]
  const [mk, setMk] = useState(markets[0][0])
  const [data, setData] = useState(undefined)   // undefined=loading, null=none
  const [idx, setIdx] = useState(0)
  useEffect(() => { let live = true; setData(undefined)
    if (!e.gsis_id) { setData(null); return }
    getNFLCombo(e.gsis_id, mk, season, week, { curve: 1 }).then(d => {
      if (!live) return
      if (!d || !d.curve || !d.curve.length) { setData(null); return }
      setData(d)
      // Start the slider at the player's standard line.
      const si = d.curve.findIndex(pt => Math.abs(pt.line - d.line) < 0.6)
      setIdx(si >= 0 ? si : Math.floor(d.curve.length / 2))
    })
    return () => { live = false }
  }, [e.gsis_id, mk, season, week])

  const mkToggle = markets.length > 1 && (
    <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
      {markets.map(([k, lbl]) => (
        <button key={k} onClick={() => setMk(k)} style={{ flex: 1, padding: '7px 0', borderRadius: 20, cursor: 'pointer',
          border: `1px solid ${k === mk ? T.green : T.border}`, background: k === mk ? T.green : T.card,
          color: k === mk ? '#04140D' : T.muted, fontSize: 12, fontWeight: 800 }}>{lbl}</button>
      ))}
    </div>
  )
  if (data === undefined) return <div style={{ padding: 16 }}>{mkToggle}<Spinner /></div>
  if (!data) return <div style={{ padding: 16 }}>{mkToggle}<div style={{ color: T.muted, fontSize: 13, lineHeight: 1.5 }}>No {markets.find(x=>x[0]===mk)?.[1] || 'yards'} + TD projection for this player this week.</div></div>

  const curve = data.curve
  const pt = curve[Math.max(0, Math.min(idx, curve.length - 1))]
  const pY = Math.round((pt.p_yards || 0) * 100)
  const pTD = Math.round((data.p_td || 0) * 100)
  const joint = Math.round((pt.joint || 0) * 100)
  const naive = Math.round((pt.p_yards || 0) * (data.p_td || 0) * 100)
  const lift = joint - naive
  return (
    <div style={{ padding: '4px 2px 8px' }}>
      {mkToggle}
      <div style={{ fontSize: 11.5, color: T.muted, marginBottom: 12, lineHeight: 1.45 }}>
        Drag to set the yards line. The big number is the model's chance {e.full_name || e.name} clears it <b style={{ color: T.text }}>and</b> scores a TD — the true correlated odds, not the two multiplied.
      </div>

      {/* Live joint */}
      <div style={{ textAlign: 'center', background: T.card2, border: `1px solid ${T.border2}`, borderRadius: 14, padding: '16px 12px', marginBottom: 12 }}>
        <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 40, lineHeight: 1, color: probColor(joint/100) }}>{joint}%</div>
        <div style={{ fontSize: 11, color: T.muted, marginTop: 5 }}>
          over <b style={{ color: T.text }}>{pt.line}</b> {markets.find(x=>x[0]===mk)?.[1].toLowerCase()} <b style={{ color: T.text }}>and</b> scores a TD
        </div>
      </div>

      {/* Slider */}
      <input type="range" min={0} max={curve.length - 1} step={1} value={idx}
        onChange={ev => setIdx(parseInt(ev.target.value, 10))}
        style={{ width: '100%', accentColor: T.green, margin: '2px 0 4px' }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: T.faint, marginBottom: 14 }}>
        <span>{curve[0].line}</span><span>{curve[curve.length - 1].line} {markets.find(x=>x[0]===mk)?.[1].toLowerCase()}</span>
      </div>

      {/* The two legs + the correlation lift */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
        <Stat label={`Over ${pt.line}`} value={`${pY}%`} color={probColor(pt.p_yards)} />
        <Stat label="Anytime TD" value={`${pTD}%`} color={tdColor(data.p_td)} />
      </div>
      <div style={{ fontSize: 11.5, color: T.muted2, background: T.card, border: `1px solid ${T.border}`, borderRadius: 9, padding: '10px 12px', lineHeight: 1.5 }}>
        Multiplied blindly that's <b style={{ color: T.text }}>{naive}%</b> — but yards and TDs move together for the same player (correlation {data.rho}), so the real combined chance is <b style={{ color: T.green }}>{joint}%</b>{lift > 0 ? ` (+${lift} pts)` : ''}.
        {data.implied_pts != null ? ` ${e.team} implied ~${data.implied_pts} pts.` : ''}
      </div>
      <div style={{ fontSize: 10, color: T.faint, marginTop: 10, textAlign: 'center' }}>Model probabilities · research, not advice · 21+</div>
    </div>
  )
}

// A tap from a list that names a specific play (Locks, TD Scorers, Fades, Due, Matchup
// Sheets, TD Matchups, …) often carries only the player + market, not the board row. Opening
// the card on that partial entry dropped the % and tier, line-shopped the wrong market, and
// let "The Case" read as a verdict on the player alone. So when the entry knows its market but
// isn't a full board row (no `confidence`), fill it from this week's board row for that market
// — the card then shows exactly what the board shows. Generic opens (search, favorites) stay
// generic: no market, nothing to fill.
const _MKT_KEY = { 'Anytime TD':'anytime_td', 'Receptions':'receptions', 'Rec Yds':'rec_yards',
  'Rush Yds':'rush_yards', 'Pass Yds':'pass_yards', 'Pass TDs':'pass_tds' }
export function PlayerModal(props){
  const { e, season = 2026, week = 1, onClose } = props
  const key = e && (e.prop_type || _MKT_KEY[e.market])
  const needs = !!(e && e.gsis_id && key && e.confidence == null)
  const [full, setFull] = useState(needs ? undefined : null)   // undefined = filling
  useEffect(() => { let live = true
    if (!needs) { setFull(null); return }
    setFull(undefined)
    getNFLPlayerProps(e.gsis_id, season, week).then(r => {
      if (!live) return
      const row = (r?.markets || []).find(m => (m.prop_type || _MKT_KEY[m.market]) === key)
      setFull(row ? { ...e, ...row } : null)
    })
    return () => { live = false }
  }, [e, key, needs, season, week])
  if (needs && full === undefined) return <Sheet onClose={onClose}><Spinner/></Sheet>
  return <PlayerCard {...props} e={full || e}/>
}

function PlayerCard({ e, season = 2026, week = 1, pro, onClose, onDefense, onAddLeg, slipKeys }){
  const [tab,setTab] = useState('Intel')
  const [detail,setDetail] = useState(undefined)   // undefined=loading, null=none
  // Prefer the real book line + the model's hit% at it once odds are pulled;
  // fall back to the canonical model line pre-odds.
  const hasBook = e.book_line!=null && !isTD(e)
  const prob = _shownProb(e) || 0
  const conf = e.confidence||0
  const shownLine = hasBook ? e.book_line : e.line
  const tier = e.tier || tierFromProb(prob, conf, e.edge_pct, e.prop_type)
  const proj = projVal(e)

  const [mu,setMu] = useState(undefined)          // matchup breakdown (undefined=loading)
  // Fetch REAL recent game logs (never fabricated). Only when we have an id.
  useEffect(()=>{ let live=true
    if(!e.gsis_id){ setDetail(null); return }
    getNFLPlayer(e.gsis_id).then(d=>{ if(live) setDetail(d && !d._sample ? d : null) })
    return ()=>{ live=false }
  },[e.gsis_id])
  const [splits,setSplits] = useState(undefined)  // historical splits vs defense types
  // Deep matchup vs the opponent — only for board plays that carry an opponent.
  useEffect(()=>{ let live=true
    if(!e.gsis_id || !e.opp){ setMu(null); return }
    // Pass the SAME hit prob + line the card headlines on (book line when priced), so
    // "The Case" can't read "21% to hit" under a card that says 82%.
    const bet = { market:e.market, line:shownLine, prob:prob, edge:e.edge_pct }
    getNFLPlayerMatchup(e.gsis_id, e.opp, e.pos||'WR', season, week, bet).then(d=>{ if(live) setMu(d && !d._sample ? d : null) })
    return ()=>{ live=false }
  },[e.gsis_id, e.opp, e.pos, e.market, shownLine, prob, season, week])
  // Historical performance splits (scheme / defense strength / this opponent).
  useEffect(()=>{ let live=true
    if(!e.gsis_id){ setSplits(null); return }
    getNFLPlayerSplits(e.gsis_id, e.opp||'', e.pos||'WR', season).then(d=>{ if(live) setSplits(d && !d._sample ? d : null) })
    return ()=>{ live=false }
  },[e.gsis_id, e.opp, e.pos, season])
  // Deeper intel — hit rate at the line, distribution, production + role trend.
  const [intel,setIntel] = useState(undefined)
  useEffect(()=>{ let live=true
    if(!e.gsis_id || !e.market){ setIntel(null); return }   // no market → nothing to measure history against
    getNFLPlayerIntel(e.gsis_id, e.market, e.line||0, season).then(d=>{ if(live) setIntel(d && d.n ? d : null) })
    return ()=>{ live=false }
  },[e.gsis_id, e.market, e.line, season])
  const logs = detail?.logs || []
  const fld = LOG_FIELD[e.market] || 'rec_yds'
  const hasProb = e.prob_over != null
  const comps = components(e)
  return (
    <Sheet onClose={onClose}>
      <div style={{padding:"8px 16px 22px"}}>
        {/* Header */}
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:6,marginBottom:4}}>
          <div style={{display:"flex",alignItems:"center",gap:11,minWidth:0}}>
            <Avatar url={e.headshot} name={e.full_name || e.name} team={e.team} size={46}/>
            <div style={{minWidth:0}}>
              <div style={{fontSize:20,fontWeight:900}}>{e.full_name || e.name || 'Player'}</div>
              <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{fontSize:12,color:T.muted}}>{[e.pos, teamNick(e.team)].filter(Boolean).join(' · ')}{e.opp ? ` · vs ${teamNick(e.opp)}` : ''}</span>
                <EpaBadge epa={detail?.epa} pos={e.pos || detail?.pos}/>
              </div>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
            {hasProb ? <TierBadge tier={tier}/> : null}
            {e.gsis_id && <FavStar player={{ gsis_id:e.gsis_id, full_name:e.full_name||e.name, team:e.team, pos:e.pos }} size={22}/>}
            {hasProb && e.gsis_id && (
              <button onClick={()=>sharePick({ name:e.full_name||e.name, pos:e.pos, team:e.team, opp:e.opp,
                market:e.market, line:hasBook?e.book_line:e.line, isTD:isTD(e),
                prob:_shownProb(e), edge:e.edge_pct,
                book:e.book_used?bookName(e.book_used):null, verdict:e.case?.verdict })}
                aria-label="Share pick" title="Share pick"
                style={{background:"none",border:"none",cursor:"pointer",color:T.green,padding:4,lineHeight:0}}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>
              </button>
            )}
          </div>
        </div>
        {/* Score strip — only real numbers; nothing fabricated when a projection is absent */}
        {hasProb && (
        <div style={{display:"grid",gridTemplateColumns:`repeat(${2+(conf?1:0)+(isTD(e)?0:1)},1fr)`,gap:8,margin:"12px 0"}}>
          <Stat label={isTD(e)?"Prob to score":"Prob Over"} value={pct(prob)} color={playColor(prob, e)} bg={prob>=0.6?T.greenDim:T.card2}/>
          {conf ? <Stat label="Confidence" value={conf} color={confColor(conf)}/> : null}
          <Stat label={e.market} value={proj!=null?proj.toFixed(1):pct(prob)}/>
          {!isTD(e) && <Stat label={hasBook?"Book line":"Line"} value={shownLine}/>}
        </div>
        )}

        {/* Live in-game progress vs the line — present while the player's game is live/final
            (as of when this card was opened). */}
        {e.live && (
          <div style={{display:"flex",alignItems:"center",gap:9,margin:"0 0 12px",padding:"9px 12px",borderRadius:10,
              background:e.live.status==='hit'?T.greenDim:T.card2,border:`1px solid ${e.live.status==='hit'?T.green:T.border2}`}}>
            {e.live.state==='in' && <span style={{width:8,height:8,borderRadius:"50%",background:T.green,display:"inline-block",flexShrink:0}}/>}
            <span style={{fontSize:10,fontWeight:800,letterSpacing:".05em",flexShrink:0,
                color:e.live.status==='hit'?T.green:e.live.status==='miss'?T.red:T.text}}>
              {e.live.status==='hit'?'HIT':e.live.status==='miss'?'MISS':(e.live.state==='post'?'FINAL':'LIVE')}</span>
            <span style={{fontFamily:T.mono,fontWeight:800,fontSize:14,flexShrink:0,
                color:e.live.status==='hit'?T.green:e.live.status==='miss'?T.red:T.text}}>
              {isTD(e) ? (e.live.cleared?'Scored ✓':e.live.state==='post'?'Did not score':'No TD yet')
                       : `${e.live.actual} / ${e.live.line}${e.live.status==='hit'?' ✓':''}`}</span>
            {!isTD(e) && (
              <span style={{flex:1,minWidth:30,height:6,borderRadius:3,background:T.border,overflow:"hidden"}}>
                <span style={{display:"block",height:"100%",borderRadius:3,
                    width:`${Math.max(0,Math.min(1,(e.live.line>0?e.live.actual/e.live.line:0)))*100}%`,
                    background:e.live.status==='miss'?T.red:T.green}}/>
              </span>
            )}
          </div>
        )}

        {/* Fantasy summary — when opened from a fantasy surface, lead with the lineup
            read (projected points, floor/ceiling range, start/sit verdict + write-up),
            not the betting card. A fantasy tap carries no single market/prob, so the
            betting strip above already hides; this fills that space with what a fantasy
            manager actually wants. */}
        {e.fantasy && (
          <div style={{ background: T.card, border: `1px solid ${T.border2}`, borderRadius: 12, padding: '13px 14px', margin: '12px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: e.fantasy_writeup ? 11 : 0 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                <div>
                  <div style={{ fontFamily: T.mono, fontWeight: 900, fontSize: 26, lineHeight: 1, color: probColor((e.fantasy_pts || 0) / 25) }}>{e.fantasy_pts != null ? e.fantasy_pts : '—'}</div>
                  <div style={{ fontSize: 10, color: T.muted, letterSpacing: '0.08em', marginTop: 3 }}>PROJ PTS{e.fantasy_scoring ? ` · ${e.fantasy_scoring.toUpperCase()}` : ''}</div>
                </div>
                {(e.fantasy_floor != null && e.fantasy_ceiling != null) && (
                  <div style={{ fontFamily: T.mono, fontSize: 12, color: T.faint }}>{e.fantasy_floor}–{e.fantasy_ceiling}<div style={{ fontSize: 10, color: T.muted, letterSpacing: '0.06em', marginTop: 2 }}>FLOOR–CEIL</div></div>
                )}
              </div>
              {e.fantasy_verdict && <VerdictChip label={e.fantasy_verdict} level={FTSY_VLEVEL[e.fantasy_verdict]} size={10} />}
            </div>
            {e.fantasy_writeup && <div style={{ fontSize: 13, lineHeight: 1.5, color: T.text }}>{e.fantasy_writeup}</div>}
          </div>
        )}

        {/* Line shop — best price across every US book + our edge, once lines are
            pulled; otherwise say so plainly (props post ~1–2 days before kickoff). */}
        {hasProb && e.market && <LineShop e={e} isTD={isTD(e)} shownLine={shownLine} season={season} week={week}/>}

        {/* Value vs the price — whether the model beats the posted number (+EV). This is a
            research read on the NUMBER, not a wager-size recommendation: we flag value, we
            don't tell anyone how much to bet. */}
        {hasProb && e.book_over_odds != null && (
          <div style={{ background: e.value ? T.greenDim : T.card2, border: `1px solid ${e.value ? `${T.green}55` : T.border}`,
            borderRadius: 12, padding: '11px 13px', marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: T.muted, fontWeight: 700, letterSpacing: '0.04em' }}>VALUE VS THE PRICE</div>
            {e.value ? (
              <div style={{ fontSize: 16, fontWeight: 900, color: T.green, marginTop: 3 }}>
                ✓ Beats the price{e.edge_pct != null ? <span style={{ fontSize: 13, color: T.muted2, fontWeight: 700 }}> · +{e.edge_pct.toFixed(1)}% edge vs the market</span> : null}
              </div>
            ) : (
              <div style={{ fontSize: 14, fontWeight: 700, color: T.muted, marginTop: 3 }}>No value at this price</div>
            )}
            <div style={{ fontSize: 10, color: T.muted, marginTop: 7, lineHeight: 1.4 }}>
              Our fair probability vs the book's vig-free number. Informational only — LINEBRKR does not advise bet sizing. 21+ · research only.
            </div>
          </div>
        )}

        {/* Add this exact bet to the mixed-market parlay slip (any market can stack). */}
        {hasProb && onAddLeg && e.gsis_id && MARKET_KEY[e.market] && (() => {
          const prop = MARKET_KEY[e.market]
          const added = slipKeys && slipKeys.has(`${e.gsis_id}:${prop}`)
          const leg = { gsis_id: e.gsis_id, prop, market: e.market,
            name: e.full_name || e.name, team: e.team, opp: e.opp, pos: e.pos, line: shownLine }
          return (
            <button onClick={() => onAddLeg(leg)} disabled={added}
              style={{ width: '100%', padding: '10px 0', marginBottom: 12, borderRadius: 10, cursor: added ? 'default' : 'pointer',
                fontWeight: 800, fontSize: 12.5, border: `1px solid ${T.green}`,
                background: added ? T.greenDim : 'transparent', color: T.green }}>
              {added ? '✓ In your parlay slip' : `＋ Add to parlay · ${isTD(e) ? 'Anytime TD' : `${playText(e.market, shownLine)}`}`}
            </button>
          )
        })()}

        {/* Bet the game on Kalshi — Kalshi carries game markets, not player props, so this
            hands off to THIS player's game (where there's an actual Kalshi market). */}
        {hasProb && (e.team || e.game_id) && <KalshiBetButton gameId={e.game_id} team={e.team} season={season} week={week}/>}

        {/* Log this play to your record / The Wall — the community spine. */}
        {hasProb && e.gsis_id && MARKET_KEY[e.market] && (
          <LogPickButton pick={{
            season, week, gsis_id: e.gsis_id, prop_type: MARKET_KEY[e.market], market: e.market,
            line: shownLine, disp_prob: prob, name: e.full_name || e.name, team: e.team,
            pos: e.pos, isTD: isTD(e),
          }} />
        )}

        <Tabs tabs={['Intel','Trends','Form','Usage','Yards+TD','Matchup']} active={tab} onSelect={t=>{ track('card_tab', t); setTab(t) }}/>

        {tab==='Yards+TD' && <ComboBuilder e={e} season={season} week={week}/>}

        {tab==='Intel' && (
          <div>
            {/* Due to Score — leads the Intel tab so the TD-regression read is the first
                thing seen, the way a competitor's "cheat code" card front-loads it. */}
            <DueToScore dts={detail?.due_to_score}/>
            <EpaPanel epa={detail?.epa}/>
            {/* The Case — green-check verdict. Futures taps carry a season-long case;
                weekly plays fold the model's own factors in so it's substantive even
                before live matchup data loads. */}
            {(() => { const tc = e.case_future || mergeCase(mu?.case, e); return tc && <TheCase tc={tc}/> })()}
            {why(e) && <div style={{fontSize:12,color:T.muted2,fontStyle:"italic",marginBottom:12,lineHeight:1.4}}>{why(e)}</div>}
            {!hasProb && !e.fantasy && !(e.impact?.factors?.length) && !comps.length && (
              <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>Open this player from the board (Home or Bets) for the full projection and factor breakdown.</div>
            )}

            {/* Bet impact — every factor in one currency: probability points toward hitting.
                Pro-only: it's the deep waterfall; Simple keeps The Case + the headline read. */}
            {pro && e.impact?.factors && (
              <BetImpact impact={e.impact} edge={e.edge_pct}
                bet={isTD(e)?'To score · Anytime TD':playText(e.market, shownLine)}/>
            )}

            {/* Fallback: raw multiplier bars only when we couldn't compute impact */}
            {!e.impact?.factors && comps.map((c,i)=>(
              <div key={i} style={{marginBottom:10}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:4}}>
                  <span style={{color:T.text}}>{c.label} <span style={{color:T.faint}}>· {c.note}</span></span>
                  <span style={{fontFamily:T.mono,color:c.mult>=1?T.green:T.red}}>×{c.mult.toFixed(2)}</span>
                </div>
                <div style={{height:5,background:T.card2,borderRadius:3,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${Math.min(100,Math.max(8,(c.mult-0.7)*140))}%`,background:c.mult>=1?T.green:T.amber,borderRadius:3}}/>
                </div>
              </div>
            ))}
          </div>
        )}

        {tab==='Trends' && (
          intel===undefined ? <div style={{fontSize:12,color:T.muted,padding:"16px 0"}}>Loading intel…</div>
          : !intel ? <div style={{fontSize:12,color:T.muted,padding:"16px 0",lineHeight:1.5}}>
              Not enough game history yet for a trend read. Fills in as he banks games.</div>
          : (()=>{ const ln=intel.line, isT=isTD(e)
            const trUp=intel.trend>0, usUp=intel.usage_delta>0
            const rateCol = intel.hit.rate>=65?T.green:intel.hit.rate>=50?T.mint:intel.hit.rate>=35?T.amber:T.red
            return (
            <div>
              {/* hit rate at the line — the floor read */}
              <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"13px 14px",marginBottom:10}}>
                <div style={{display:"flex",alignItems:"baseline",justifyContent:"space-between"}}>
                  <span style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.05em"}}>{isT?'Scored a TD':`Cleared ${e.market} ${ln}`}</span>
                  <span style={{fontFamily:T.mono,fontWeight:900,fontSize:22,color:rateCol}}>{intel.hit.rate}%</span>
                </div>
                <div style={{fontSize:12,color:T.muted,marginTop:2}}>{intel.hit.hits} of his last {intel.hit.n} games</div>
                <div style={{height:6,background:T.card2,borderRadius:3,overflow:"hidden",marginTop:9}}>
                  <div style={{height:"100%",width:`${intel.hit.rate}%`,background:rateCol,borderRadius:3}}/>
                </div>
              </div>

              {/* distribution — floor / median / ceiling */}
              {!isT && (
                <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px",marginBottom:10}}>
                  <div style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:9}}>Range · vs the {ln} line</div>
                  <div style={{display:"flex",justifyContent:"space-between",textAlign:"center"}}>
                    {[['Floor',intel.dist.floor],['Median',intel.dist.median],['Ceiling',intel.dist.ceiling]].map(([k,v])=>(
                      <div key={k} style={{flex:1}}>
                        <div style={{fontFamily:T.mono,fontWeight:800,fontSize:17,color:v>ln?T.green:T.text}}>{v}</div>
                        <div style={{fontSize:10,color:T.muted,marginTop:2}}>{k}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* trend — production + role, the 'is his arrow up' read */}
              <div style={{display:"flex",gap:8,marginBottom:10}}>
                <div style={{flex:1,background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"11px 12px"}}>
                  <div style={{fontSize:10.5,color:T.muted,textTransform:"uppercase",letterSpacing:"0.04em"}}>Production</div>
                  <div style={{fontFamily:T.mono,fontWeight:800,fontSize:15,color:trUp?T.green:intel.trend<0?T.amber:T.muted,marginTop:3}}>
                    {trUp?'▲':intel.trend<0?'▼':'—'} {intel.trend>0?'+':''}{intel.trend}</div>
                  <div style={{fontSize:10,color:T.faint,marginTop:1}}>last 3 vs prior</div>
                </div>
                <div style={{flex:1,background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"11px 12px"}}>
                  <div style={{fontSize:10.5,color:T.muted,textTransform:"uppercase",letterSpacing:"0.04em"}}>Role · {intel.usage_label}</div>
                  <div style={{fontFamily:T.mono,fontWeight:800,fontSize:15,color:usUp?T.green:intel.usage_delta<0?T.amber:T.muted,marginTop:3}}>
                    {usUp?'▲':intel.usage_delta<0?'▼':'—'} {intel.usage_delta>0?'+':''}{intel.usage_delta}</div>
                  <div style={{fontSize:10,color:T.faint,marginTop:1}}>{usUp?'role growing':intel.usage_delta<0?'role shrinking':'steady'}</div>
                </div>
              </div>

              {/* boom / bust — how often he smashes vs busts the line */}
              <div style={{display:"flex",gap:8,fontSize:12}}>
                <div style={{flex:1,background:T.greenDim,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 11px"}}>
                  <b style={{color:T.green,fontFamily:T.mono}}>{intel.boom}</b> <span style={{color:T.muted}}>{isT?'games scored':'boom games'}</span></div>
                <div style={{flex:1,background:T.card2,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 11px"}}>
                  <b style={{color:T.amber,fontFamily:T.mono}}>{intel.bust}</b> <span style={{color:T.muted}}>{isT?'blanked':'bust games'}</span></div>
              </div>
              {/* Situational splits — home/road · dome/out · turf/grass · fav/dog */}
              {(()=>{ const S=intel.situational||{}
                const PAIRS=[['home','Home','road','Road'],['indoor','Dome','outdoor','Outdoor'],
                  ['turf','Turf','grass','Grass'],['favorite','Favorite','underdog','Underdog'],
                  ['calm','Calm','windy','Wind 15+'],['off_bye','Off bye','short_week','Short week']]
                const has=PAIRS.filter(([lk,,rk])=>S[lk]||S[rk])
                if(!has.length) return null
                const cell=(lab,d,better)=>(
                  <div style={{flex:1,background:better?T.greenDim:T.card2,border:`1px solid ${better?T.greenMid:T.border}`,borderRadius:10,padding:'8px 10px'}}>
                    <div style={{fontSize:10,color:T.muted}}>{lab}</div>
                    {d? <>
                        <div style={{fontFamily:T.mono,fontWeight:800,fontSize:14,color:isT?T.text:(d.avg>ln?T.green:T.text)}}>{isT?`${d.rate}%`:d.avg}</div>
                        <div style={{fontSize:10,color:T.faint}}>{d.n} gm{!isT?` · ${d.rate}%`:''}</div>
                      </> : <div style={{fontSize:13,color:T.faint,marginTop:3}}>—</div>}
                  </div>
                )
                return (
                  <div style={{marginTop:12}}>
                    <div style={{fontSize:11,color:T.muted,textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:8}}>Situational · {isT?'score rate':'avg & hit rate'}</div>
                    {has.map(([lk,ll,rk,rl])=>{ const L=S[lk],R=S[rk]
                      return <div key={lk} style={{display:'flex',gap:8,marginBottom:7}}>
                        {cell(ll,L,L&&R&&L.rate>R.rate)}{cell(rl,R,L&&R&&R.rate>L.rate)}</div>
                    })}
                  </div>
                )
              })()}

              {/* Vs defense type & this opponent — historical, everything in one place */}
              {splits && splits.games>0 && (splits.vs_scheme?.zone||splits.vs_scheme?.man||splits.vs_strength?.soft||splits.vs_strength?.tough||splits.vs_opp) && (
                <div style={{marginTop:12}}>
                  <div style={{fontSize:11,color:T.muted,textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:8}}>Vs defense type · last 3 yrs</div>
                  <SplitPair la="vs Zone D" a={splits.vs_scheme?.zone} lb="vs Man D" b={splits.vs_scheme?.man} avg={splits.season_avg}/>
                  <SplitPair la="vs Soft D" a={splits.vs_strength?.soft} lb="vs Tough D" b={splits.vs_strength?.tough} avg={splits.season_avg}/>
                  {splits.vs_opp && <div style={{fontSize:12,marginTop:1}}>vs {splits.vs_opp.team}: <b style={{color:splits.season_avg!=null&&splits.vs_opp.avg>=splits.season_avg?T.green:T.text}}>{splits.vs_opp.avg}</b> <span style={{color:T.muted,fontSize:11}}>({splits.vs_opp.games} gm)</span></div>}
                </div>
              )}

              <div style={{fontSize:10,color:T.faint,marginTop:10,lineHeight:1.5}}>Floor/median/ceiling are his 25th/50th/75th-percentile games. Trend = last 3 vs earlier. Splits join each game to its venue, weather &amp; spread. Green = the better side / above the {ln} line.</div>
            </div>
          )})()
        )}

        {tab==='Form' && (
          <div>
            {detail===undefined ? (
              <div style={{fontSize:12,color:T.muted,padding:"16px 0"}}>Loading recent games…</div>
            ) : logs.length ? (<>
              {/* Season summary — averages across the shown games, so a player's form is
                  a line, not just a scroll of games. */}
              {(() => {
                const n = logs.length
                const vals = logs.map(g => g[fld] ?? 0)
                const avg = vals.reduce((s, v) => s + v, 0) / n
                const tds = logs.reduce((s, g) => s + (g.tds || 0), 0)
                const tile = (label, value) => (
                  <div style={{ flex: 1, textAlign: 'center', background: T.card2, border: `1px solid ${T.border}`, borderRadius: 9, padding: '8px 4px' }}>
                    <div style={{ fontFamily: T.mono, fontWeight: 800, fontSize: 15, color: T.text }}>{value}</div>
                    <div style={{ fontSize: 10, color: T.muted, letterSpacing: '0.04em', marginTop: 2, textTransform: 'uppercase' }}>{label}</div>
                  </div>
                )
                return (
                  <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                    {tile('Games', n)}
                    {!isTD(e) && tile(`${e.market}/g`, avg.toFixed(1))}
                    {tile('TDs', tds)}
                  </div>
                )
              })()}
              <div style={{fontSize:11,color:T.muted,marginBottom:8}}>
                Last {logs.length} games · {e.market}
                {detail?.source_season ? ` · ${detail.source_season}` : ''}
              </div>
              {logs.slice().reverse().map((g,i)=>{
                const v = g[fld] ?? 0
                const hit = isTD(e) ? v>=1 : v>shownLine
                return (
                  <div key={i} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderTop:i?`1px solid ${T.border}`:"none",fontSize:12,fontFamily:T.mono}}>
                    <span style={{color:T.muted}}>Wk {g.week} vs {g.opp||'—'}</span>
                    <span style={{color:hit?T.green:T.muted2}}>{isTD(e)?`${g.tds} TD`:v} {hit?'✓':''}</span>
                  </div>
                )
              })}
            </>) : (
              <div style={{fontSize:12,color:T.muted,padding:"16px 0",lineHeight:1.5}}>
                No recent game logs on file for this player yet. Recent form fills in as games are played.
              </div>
            )}
          </div>
        )}

        {tab==='Usage' && <UsagePanel e={e} mu={mu}/>}

        {tab==='Matchup' && (
          !e.opp ? (
            <div style={{fontSize:12,color:T.muted,lineHeight:1.5,padding:"8px 0"}}>
              Open this player from the board (Home or Bets) to see the full matchup vs this week's opponent.
            </div>
          ) : mu===undefined ? (
            <div style={{fontSize:12,color:T.muted,padding:"16px 0"}}>Loading matchup…</div>
          ) : !mu ? (
            <div style={{fontSize:12,color:T.muted,padding:"16px 0"}}>Matchup data unavailable right now.</div>
          ) : (
          <div>
            {/* Side-by-side head-to-head — HIM vs the defense, facet by facet */}
            <MatchupBreakdown e={e} mu={mu} onDefense={onDefense}/>

            {pro ? (<>
            <div style={{fontSize:10,color:T.faint,letterSpacing:'0.08em',margin:'2px 0 8px',textTransform:'uppercase'}}>Full detail</div>
            {/* Defense vs position — yds + TDs allowed, league rank (#1 = softest) */}
            <MRow label={`${teamNick(e.opp)} defense vs ${e.pos}`}>
              <MChip v={mu.defense?.yds!=null?`${mu.defense.yds} yds/g`:'—'} rank={mu.defense?.yds_rank}/>
              <MChip v={mu.defense?.td!=null?`${mu.defense.td} TD/g`:'—'} rank={mu.defense?.td_rank}/>
            </MRow>


            {/* Workload — does he get the volume (position-aware) */}
            {mu.volume && (
              <MRow label="Workload (recent/g)">
                {mu.volume.pass_att_pg!=null && <MChip v={`${mu.volume.pass_att_pg} att`}/>}
                {mu.volume.comp_pg!=null && <MChip v={`${mu.volume.comp_pg} comp`}/>}
                {mu.volume.pass_yds_pg!=null && <MChip v={`${mu.volume.pass_yds_pg} pass yds`}/>}
                {mu.volume.ypa!=null && <MChip v={`${mu.volume.ypa} YPA`}/>}
                {mu.volume.carries_pg!=null && <MChip v={`${mu.volume.carries_pg} carries`}/>}
                {mu.volume.targets_pg!=null && <MChip v={`${mu.volume.targets_pg} tgt`}/>}
                {mu.volume.rec_pg!=null && <MChip v={`${mu.volume.rec_pg} rec`}/>}
                {mu.volume.rec_yds_pg!=null && <MChip v={`${mu.volume.rec_yds_pg} rec yds`}/>}
                {mu.volume.catch_rate!=null && <MChip v={`${Math.round(mu.volume.catch_rate*100)}% catch`}/>}
              </MRow>
            )}

            {/* QB passing efficiency (Next Gen) */}
            {mu.passing && (
              <MRow label="Passing efficiency (Next Gen)">
                {mu.passing.cpoe!=null && <MChip v={`${mu.passing.cpoe>0?'+':''}${mu.passing.cpoe} CPOE`}/>}
                {mu.passing.adot!=null && <MChip v={`${mu.passing.adot} aDOT`}/>}
                {mu.passing.time_to_throw!=null && <MChip v={`${mu.passing.time_to_throw}s to throw`}/>}
              </MRow>
            )}

            {/* Run game — box, efficiency, O-line (RB, or a rushing QB) */}
            {mu.rushing && (
              <MRow label="Run game">
                {mu.rushing.box_stacked_rate!=null && <MChip v={`${Math.round(mu.rushing.box_stacked_rate)}% stacked box`}/>}
                {mu.rushing.ryoe_per_att!=null && <MChip v={`${mu.rushing.ryoe_per_att>0?'+':''}${mu.rushing.ryoe_per_att} RYOE/att`}/>}
                {mu.rushing.rush_efficiency!=null && <MChip v={`${mu.rushing.rush_efficiency} eff`}/>}
                {mu.rushing.ol_run_block_grade!=null && <MChip v={`OL run-block ${mu.rushing.ol_run_block_grade}`}/>}
              </MRow>
            )}

            {/* Where he lines up — real PFF alignment split (once PFF CSVs are loaded) */}
            {mu.alignment && (
              <MRow label="Where he lines up (PFF)">
                <div style={{fontSize:12.5}}>
                  <b style={{color:T.text}}>{mu.alignment.label}</b>
                  <div style={{fontSize:11,color:T.muted,fontFamily:T.mono,marginTop:3}}>
                    {Math.round(mu.alignment.wide_pct*100)}% wide · {Math.round(mu.alignment.slot_pct*100)}% slot{mu.alignment.inline_pct>0?` · ${Math.round(mu.alignment.inline_pct*100)}% inline`:''}
                  </div>
                </div>
              </MRow>
            )}

            {/* Likely coverage defender — named from the opponent's CB depth chart +
                this receiver's alignment (a free inference, clearly labeled). */}
            {mu.coverage && mu.coverage.likely && mu.coverage.likely.length > 0 && (
              <MRow label="Likely coverage">
                <div style={{fontSize:12.5}}>
                  {mu.coverage.likely.map((c,i)=>(
                    <span key={i}>
                      <b style={{color:T.text}}>{c.name}</b>
                      <span style={{color:T.muted}}> ({c.role})</span>
                      {i<mu.coverage.likely.length-1?<span style={{color:T.faint}}> · </span>:null}
                    </span>
                  ))}
                  {mu.coverage.role_faced && <span style={{color:T.muted}}> — he mostly works {mu.coverage.role_faced==='slot'?'the slot':'outside'}</span>}
                  <div style={{fontSize:10,color:T.faint,marginTop:4,lineHeight:1.4}}>{mu.coverage.note}</div>
                </div>
              </MRow>
            )}

            {/* Coverage scheme — the slot-vs-outside read */}
            {mu.scheme && (
              <MRow label="Coverage scheme">
                <div style={{fontSize:12.5}}>
                  <b style={{color:mu.scheme.label==='Zone-heavy'?T.mint:mu.scheme.label==='Man-heavy'?T.amber:T.text}}>{mu.scheme.label}</b>
                  <span style={{color:T.muted}}> · {mu.scheme.note}</span>
                  <div style={{fontSize:11,color:T.muted,fontFamily:T.mono,marginTop:3}}>man {Math.round(mu.scheme.man_rate*100)}% · zone {Math.round(mu.scheme.zone_rate*100)}%</div>
                  {(mu.scheme.two_high_rate||mu.scheme.single_high_rate) ? (
                    <div style={{fontSize:11,color:T.muted,fontFamily:T.mono,marginTop:3}}>
                      two-high {Math.round((mu.scheme.two_high_rate||0)*100)}% · single-high {Math.round((mu.scheme.single_high_rate||0)*100)}%
                      {mu.scheme.source_season && <span style={{color:T.faint}}> · {mu.scheme.source_season} charting</span>}
                    </div>
                  ) : null}
                </div>
              </MRow>
            )}

            {/* Where the defense is soft by depth (slot vs deep) — the "catches not
                yards" read. Data already in the matchup payload (mu.def_depth). */}
            {mu.def_depth && <DefDepth dd={mu.def_depth} opp={e.opp}/>}

            {/* Receiver profile from Next Gen Stats */}
            {mu.ngs && (
              <MRow label="How he wins (Next Gen)">
                <div style={{fontSize:11.5,color:T.muted,fontFamily:T.mono}}>
                  {mu.ngs.separation!=null && <span>sep {mu.ngs.separation}yd · </span>}
                  {mu.ngs.cushion!=null && <span>cushion {mu.ngs.cushion}yd · </span>}
                  {mu.ngs.yac!=null && <span>YAC {mu.ngs.yac} · </span>}
                  {mu.ngs.catch_pct!=null && <span>catch {mu.ngs.catch_pct}%</span>}
                </div>
                {mu.ngs.role && <div style={{fontSize:12,color:T.text,marginTop:4}}>{mu.ngs.role}</div>}
              </MRow>
            )}

            {/* Red zone + environment — inside-20 volume plus goal-line (inside-5),
                the sharpest anytime-TD signal. RB leads with carries, WR/TE targets. */}
            {(mu.redzone?.player_rz_share!=null || mu.redzone?.def_rz_td_rate!=null ||
              mu.redzone?.rz_carries || mu.redzone?.rz_targets || mu.redzone?.gl_carries || mu.redzone?.gl_targets) && (
              <MRow label="Red zone & goal line">
                {mu.redzone.player_rz_share!=null && <MChip v={`${Math.round(mu.redzone.player_rz_share*100)}% team RZ touches`}/>}
                {(e.pos==='RB'||e.pos==='QB')
                  ? <>
                      {mu.redzone.rz_carries!=null && <MChip v={`${mu.redzone.rz_carries} RZ carries`}/>}
                      {mu.redzone.gl_carries!=null && <MChip v={`${mu.redzone.gl_carries} goal-line carries`}/>}
                    </>
                  : <>
                      {mu.redzone.rz_targets!=null && <MChip v={`${mu.redzone.rz_targets} RZ targets`}/>}
                      {mu.redzone.gl_targets!=null && <MChip v={`${mu.redzone.gl_targets} goal-line targets`}/>}
                    </>}
                {mu.redzone.rz_tds!=null && <MChip v={`${mu.redzone.rz_tds} RZ TD`}/>}
                {mu.redzone.def_rz_td_rate!=null && <MChip v={`${e.opp} allows ${Math.round(mu.redzone.def_rz_td_rate*100)}% RZ TD`}/>}
              </MRow>
            )}
            {(mu.pace!=null || mu.pressure!=null) && (
              <MRow label="Environment">
                {mu.pace!=null && <MChip v={`${mu.pace} plays/g`}/>}
                {mu.pressure!=null && <MChip v={`${Math.round(mu.pressure*100)}% ${e.pos==='QB'?'pass rush':'pressure'}`}/>}
              </MRow>
            )}

            {(mu.scheme_flux?.opp_def || mu.scheme_flux?.team_off) && (
              <div style={{fontSize:11,color:T.amber,background:T.amberDim,border:`1px solid ${T.amber}44`,
                borderRadius:8,padding:'7px 10px',marginTop:8,lineHeight:1.45}}>
                ⚠ Scheme in flux — {mu.scheme_flux.opp_def && `${e.opp} ${mu.scheme_flux.opp_def_new_dc ? 'hired a new defensive coordinator' : 'is playing a different scheme than last year'}, so this matchup is a weaker read`}
                {mu.scheme_flux.opp_def && mu.scheme_flux.team_off && '; '}
                {mu.scheme_flux.team_off && `${e.team||'his team'} ${mu.scheme_flux.team_off_new_oc ? 'has a new offensive coordinator' : 'is running a different scheme than last year'}, so role/usage may shift`}.
              </div>
            )}
            <div style={{fontSize:10,color:T.muted,marginTop:8,lineHeight:1.5}}>
              {(e.pos==='WR'||e.pos==='TE') && (mu.alignment
                ? 'Alignment is real PFF snap data; coverage scheme shows how the defense gives it up — zone concedes slot/underneath, man gets beaten outside & deep. '
                : 'Coverage scheme is the honest slot-vs-outside signal — zone concedes underneath/slot, man gets beaten outside & deep. True slot/wide alignment fills in once PFF snap-count CSVs are uploaded. ')}
              {mu.defense?.source_season && mu.defense.source_season!==2026 &&
                `Defense reflects ${mu.defense.source_season} play — it does not yet account for this year's coaching, roster, or scheme changes, and sharpens as the season is played.`}
            </div>
            </>) : null}
            {/* Coverage IQ — zone/man per-route splits, first-read share and the opponent's coverage
                mix, with a plain-English fit. Shown in Simple and Pro: it's a play-finding read. */}
            {e.gsis_id && ['WR','TE','RB'].includes((e.pos||e.position||'').toUpperCase()) &&
              <CoverageIQ gsis={e.gsis_id} opp={e.opp} season={season}/>}
            {!pro && (
              <div style={{fontSize:11.5,color:T.muted,padding:'2px 0',lineHeight:1.5}}>Flip <b style={{color:T.green}}>Pro</b> (top right) for the full detail — defense ranks, workload, Next Gen efficiency, coverage scheme &amp; red-zone role.</div>
            )}
          </div>
          )
        )}

        {/* Status footer — only for board plays that carry a real status (weekly props).
            Futures/trends taps have no game status, so we omit it rather than show "undefined". */}
        {e.status && (
          <div style={{background:T.card3,borderRadius:6,padding:"7px 10px",marginTop:14,fontSize:11,color:e.status==='out'?T.red:e.status==='active'?T.green:T.amber}}>
            {e.status==='out'?'✕ Ruled out':e.status==='active'?'✓ Active':'⚠ '+e.status} · inactives post ~90 min pre-kick
          </div>
        )}
      </div>
    </Sheet>
  )
}

// ── Game modal — "The Read" ─────────────────────────────────────────────────
// Rank color — 1 = softest (attack, green) … 32 = toughest (avoid, red).
const rankColor = r => r == null ? T.muted : r <= 8 ? T.green : r <= 16 ? T.mint : r <= 24 ? T.amber : T.red
const rankChip = r => r == null ? <span style={{color:T.muted}}>—</span>
  : <span style={{color:rankColor(r),fontWeight:800,fontSize:11}}>#{r}</span>

// One side of the ball: an offense vs the opponent's defense, per skill unit.
// A one-word verdict on a matchup unit from the opponent's yards-allowed rank
// (1 = allows the most = softest). The fast read; the yards/ranks stay as support.
function attackVerdict(rank){
  if(rank==null) return {label:"—", c:T.muted, bg:T.card2, bd:T.border}
  if(rank<=10)   return {label:"ATTACK", c:T.green, bg:T.greenDim, bd:T.greenMid}
  if(rank>=23)   return {label:"FADE",   c:T.red, bg:"transparent", bd:T.red}
  return {label:"EVEN", c:T.muted, bg:T.card2, bd:T.border2}
}

function EdgePanel({ off, def, rows }){
  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,overflow:"hidden",marginBottom:8}}>
      <div style={{fontSize:11,fontWeight:800,color:T.text,padding:"9px 12px",borderBottom:`1px solid ${T.border}`}}>
        {off} offense <span style={{color:T.muted,fontWeight:600}}>vs {def} defense</span>
      </div>
      {(rows||[]).map((e,i)=>{ const v=attackVerdict(e.yds_rank); return (
        <div key={i} style={{display:"flex",alignItems:"center",gap:10,
          padding:"8px 12px",borderTop:i?`1px solid ${T.border}`:"none"}}>
          <span style={{fontSize:12,fontWeight:700,color:T.text,width:40}}>{e.unit}</span>
          <span style={{flex:1,fontSize:10.5,color:T.muted,fontFamily:T.mono,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
            {e.yds!=null?`${e.yds} yds/g · yds #${e.yds_rank??'—'} · TD #${e.td_rank??'—'}`:'—'}
          </span>
          <span style={{flex:"none",fontSize:10,fontWeight:800,letterSpacing:"0.03em",color:v.c,
            background:v.bg,border:`1px solid ${v.bd}`,borderRadius:7,padding:"3px 8px"}}>{v.label}</span>
        </div>
      )})}
    </div>
  )
}

// "Most likely to score" — one team's players ranked by anytime-TD probability, each tagged
// with the opponent weakness driving it (how soft the opponent is to that position's TDs +
// its red-zone TD rate allowed). rank 1 = opponent allows the MOST of that TD type.
const _ordinal = n => { if(n==null) return null; const v=n%100, s=["th","st","nd","rd"]; return n+(s[(v-20)%10]||s[v]||s[0]) }
const _TD_WORD = { RB:"rushing", WR:"receiving", TE:"receiving", QB:"passing" }
// Clean, pasteable one-liner-per-player summary of the scoring read — for a chat / notes / a post.
function buildScorerText(g){
  const line = (r,i) => {
    const word = _TD_WORD[r.pos] || "total"
    const weak = r.td_soft_rank!=null ? ` — ${r.opp} ${_ordinal(r.td_soft_rank)}-most ${word} TDs` : ""
    return `${i+1}. ${r.name} ${r.pos} ${r.prob!=null?Math.round(r.prob*100)+"%":"—"}${weak}`
  }
  const block = (abbr, rows) => rows && rows.length ? [`${abbr}:`, ...rows.map(line)].join("\n") : null
  return [`${g.away.abbr} @ ${g.home.abbr} — most likely to score (anytime TD)`,
          block(g.away.abbr, g.scorers?.away), block(g.home.abbr, g.scorers?.home)]
         .filter(Boolean).join("\n\n")
}

// Full game report as shareable text — the read (write-up) + top plays per side + the
// most-likely-to-score list. This is what "export game write-ups and plays" produces.
function buildGameReport(g){
  const L = []
  L.push(`${g.away?.abbr || ''} @ ${g.home?.abbr || ''}${g.day ? ` — ${g.day}${g.time ? ' ' + g.time : ''}` : ''}`.trim())
  if (g.total != null) {
    const imp = g.implied && g.implied.away != null ? ` · ${g.away.abbr} ${g.implied.away} / ${g.home.abbr} ${g.implied.home} implied` : ''
    L.push(`O/U ${g.total}${imp}`)
  }
  if (Array.isArray(g.read) && g.read.length) {
    L.push('', 'THE READ:')
    g.read.forEach(r => L.push(`• ${r}`))
  }
  const plays = (abbr, rows) => {
    if (!rows || !rows.length) return
    L.push('', `${abbr} — top plays:`)
    rows.forEach(p => {
      const pr = p.prob != null ? ` — ${Math.round(p.prob * 100)}%` : ''
      const ln = p.line != null ? ` ${p.line}` : ''
      // Mark a projected line (no posted book number) so a shared/exported card never reads a
      // model average as if it were the book line.
      const projTag = (p.market !== 'Anytime TD' && p.book_line == null && p.line != null) ? ' (proj)' : ''
      const ed = p.edge_pct != null ? ` (${p.edge_pct > 0 ? '+' : ''}${p.edge_pct}% edge)` : ''
      L.push(`• ${p.name} ${p.market}${ln}${projTag}${pr}${ed}`)
    })
  }
  plays(g.away?.abbr, g.topPlaysAway)
  plays(g.home?.abbr, g.topPlaysHome)
  const sc = buildScorerText(g)
  if (sc) L.push('', sc)
  L.push('', '— LINEBRKR · research only, not betting advice · 21+')
  return L.join('\n')
}

// Export = native share sheet on mobile (send to any app), clipboard copy elsewhere.
function ExportBtn({ text, title, label = 'Export game report' }){
  const [done, setDone] = useState(false)
  const go = () => {
    const ok = () => { setDone(true); setTimeout(() => setDone(false), 1500) }
    try {
      if (navigator.share) { navigator.share({ title, text }).then(ok).catch(() => {}) ; return }
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(text).then(ok, ok)
      else { const t = document.createElement('textarea'); t.value = text; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); ok() }
    } catch (_) { ok() }
  }
  return (
    <button onClick={go} style={{ cursor: 'pointer', fontWeight: 800, fontSize: 12.5, width: '100%',
      padding: '10px 0', borderRadius: 10, color: done ? '#04140D' : T.green, background: done ? T.green : T.greenDim,
      border: `1px solid ${T.green}${done ? '' : '55'}`, marginBottom: 12 }}>
      {done ? '✓ Exported' : `⤴ ${label}`}
    </button>
  )
}

function ScorerCopyBtn({ text }){
  const [done, setDone] = useState(false)
  const copy = () => {
    const ok = () => { setDone(true); setTimeout(()=>setDone(false), 1500) }
    try {
      if(navigator.clipboard?.writeText) navigator.clipboard.writeText(text).then(ok, ok)
      else { const t=document.createElement("textarea"); t.value=text; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove(); ok() }
    } catch(_) { ok() }
  }
  return (
    <button onClick={copy} style={{cursor:"pointer",fontFamily:T.mono,fontWeight:700,fontSize:10.5,
      padding:"4px 9px",borderRadius:8,color:done?"#04140D":T.green,background:done?T.green:T.greenDim,
      border:`1px solid ${T.green}${done?"":"55"}`,whiteSpace:"nowrap"}}>{done?"✓ Copied":"⧉ Copy"}</button>
  )
}

function ScorerPanel({ off, rows }){
  if(!rows || !rows.length) return null
  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:10,overflow:"hidden",marginBottom:8}}>
      <div style={{fontSize:11,fontWeight:800,color:T.text,padding:"9px 12px",borderBottom:`1px solid ${T.border}`}}>{off} · most likely to score</div>
      {rows.map((r,i)=>{
        const soft = r.td_soft_rank
        const c = soft==null?T.muted : soft<=8?T.green : soft<=16?T.mint : soft<=24?T.amber : T.red
        const word = _TD_WORD[r.pos] || "total"
        const weak = soft!=null ? `${r.opp} allows the ${_ordinal(soft)}-most ${word} TDs` : null
        const rz = r.rz_td_rate_allowed!=null ? `${Math.round(r.rz_td_rate_allowed*100)}% RZ TD rate` : null
        const sub = [weak, rz].filter(Boolean).join(" · ") || "opponent scoring-defense data pending"
        return (
          <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",borderTop:i?`1px solid ${T.border}`:"none"}}>
            <span style={{fontSize:11,color:T.faint,fontFamily:T.mono,width:14}}>{i+1}</span>
            <div style={{minWidth:0,flex:1}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{r.name} <span style={{color:T.muted,fontWeight:600,fontSize:10.5}}>{r.pos}</span></div>
              <div style={{fontSize:10,color:c,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{sub}</div>
            </div>
            <span style={{fontFamily:T.mono,fontWeight:800,fontSize:14,color:probColor(r.prob||0)}}>{r.prob!=null?`${Math.round(r.prob*100)}%`:'—'}</span>
          </div>
        )
      })}
    </div>
  )
}

function InjuryList({ team, list }){
  if(!list || !list.length) return null
  const col = s => s==='Out'?T.red : s==='Doubtful'?T.amber : T.muted2
  return (
    <div style={{marginBottom:8}}>
      <div style={{fontSize:11,fontWeight:800,color:T.text,marginBottom:5}}>{team} injuries</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:5}}>
        {list.map((p,i)=>(
          <span key={i} style={{fontSize:10.5,fontWeight:700,color:col(p.status),background:T.card2,
            border:`1px solid ${T.border}`,borderRadius:6,padding:"3px 8px"}}>
            {p.name} <span style={{color:T.muted}}>{p.pos}</span> · {p.status[0]}
          </span>
        ))}
      </div>
    </div>
  )
}

// Opponent DEFENSIVE injuries that create an opening for this team's offense — the "a defender
// out helps the other side" read. Highlighted because it's an actionable edge, not just a status.
function DefImpact({ away, home, data }){
  if(!data) return null
  const sides = [[away, home, data.away], [home, away, data.home]]   // [offense team, defense team, injuries]
  if(!((data.away?.length||0) + (data.home?.length||0))) return null
  return (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,fontWeight:900,color:T.green,marginBottom:6}}>⚡ Defensive injuries → offense opens up</div>
      {sides.map(([off, def, list], si)=> (list && list.length) ? (
        <div key={si} style={{background:T.greenDim,border:`1px solid ${T.green}44`,borderRadius:10,padding:"9px 11px",marginBottom:6}}>
          <div style={{fontSize:12,fontWeight:900}}>{off} offense gets a lift</div>
          {list.map((p,i)=>(
            <div key={i} style={{fontSize:11,color:T.muted2||T.muted,marginTop:3,lineHeight:1.4}}>
              <b style={{color:T.text}}>{def} {p.name} <span style={{color:T.muted}}>{p.pos}</span></b>{' '}
              <span style={{color:p.status==='Out'?T.red:T.amber,fontWeight:800}}>{p.status}</span> — {p.why}
            </div>
          ))}
        </div>
      ) : null)}
    </div>
  )
}

function PlaysList({ label, plays }){
  if(!plays || !plays.length) return <div style={{fontSize:11,color:T.muted,marginBottom:8}}>{label}: no qualified plays</div>
  return (
    <div style={{marginBottom:10}}>
      <div style={{fontSize:11,fontWeight:800,color:T.text,margin:"2px 0 6px"}}>{label}</div>
      {plays.map((p,i)=>(
        <div key={i} style={{display:"flex",alignItems:"center",gap:10,
          background:T.card,border:`1px solid ${(p.prob||0)>=0.6?T.greenMid:T.border}`,borderRadius:10,padding:"9px 12px",marginBottom:6}}>
          <RatingBadge tier={p.tier || tierFromProb(p.prob||0, p.conf||0, p.edge_pct, p.prop_type)} size={32}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:800,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>
              {p.name} <span style={{fontSize:11,color:T.muted,fontWeight:700}}>{p.pos}</span></div>
            <div style={{fontSize:11,color:T.muted,marginTop:2}}>{playText(p.market, p.line)}
              {p.market!=='Anytime TD' && p.book_line==null && (
                <span title="No posted book line yet — this is our PROJECTED line, not a book number"
                  style={{marginLeft:6,fontSize:10,fontWeight:800,letterSpacing:'0.04em',color:T.amber,
                    background:T.amberDim,border:`1px solid ${T.amber}`,borderRadius:4,padding:'1px 5px'}}>PROJ</span>
              )}
              {p.edge_pct!=null&&p.edge_pct>=3?` · +${p.edge_pct.toFixed(0)}% edge`:''}</div>
          </div>
          <div style={{textAlign:"right",flexShrink:0}}>
            <div style={{fontFamily:T.mono,fontWeight:800,color:probColor(p.prob||0)}}>{pct(p.prob||0)}</div>
            <div style={{fontSize:10,color:T.muted}}>conf {p.conf}</div>
          </div>
        </div>
      ))}
    </div>
  )
}

// "How our model sees it" — leads the game view with our OWN outcome model
// (opponent-adjusted, market-anchored) vs the book: projected score, win%, and the
// spread/total lean. Answers "how do these teams fare?" before any of the detail below.
// Renders from g.proj (the game-outcome model already on the slate game); hidden if absent.
function GameModelBlock({ g }){
  const p = g.proj
  if(!p || p.home_pts==null) return null
  const homeFav = (p.margin||0) >= 0
  const favAbbr = homeFav ? g.home.abbr : g.away.abbr
  const byPts = Math.abs(p.margin||0).toFixed(1).replace(/\.0$/,'')
  const wp = Math.round((p.home_win_prob!=null?p.home_win_prob:0.5)*100)
  const atsBig = p.ats_edge!=null && Math.abs(p.ats_edge)>=1.5
  const ouBig = p.ou_edge!=null && Math.abs(p.ou_edge)>=2
  const num = {fontFamily:T.mono,fontWeight:800}
  return (
    <div style={{background:T.card,border:`1px solid ${T.greenMid}`,borderRadius:14,padding:14,marginBottom:12}}>
      <div style={{fontSize:10.5,letterSpacing:"0.08em",textTransform:"uppercase",color:T.muted,fontWeight:700,marginBottom:10}}>How our model sees it</div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:11}}>
        <span style={{fontSize:12,color:T.muted,fontWeight:700}}>{g.away.abbr}</span>
        <span style={{...num,fontSize:28}}>{p.away_pts}</span>
        <span style={{color:T.muted,fontSize:18}}>–</span>
        <span style={{...num,fontSize:28}}>{p.home_pts}</span>
        <span style={{fontSize:12,color:T.muted,fontWeight:700}}>{g.home.abbr}</span>
      </div>
      <div style={{textAlign:"center",fontSize:11.5,color:T.muted,marginTop:3}}>{favAbbr} by {byPts} · total {p.total}</div>
      <div style={{display:"flex",height:8,borderRadius:5,overflow:"hidden",margin:"12px 0 5px",background:T.card2}}>
        <div style={{width:`${100-wp}%`,background:"#39424f"}}/>
        <div style={{width:`${wp}%`,background:T.green}}/>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:T.muted,fontFamily:T.mono}}>
        <span>{g.away.abbr} {100-wp}%</span><span>{g.home.abbr} {wp}%</span>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginTop:12}}>
        <div style={{background:T.card2,borderRadius:10,padding:"9px 11px"}}>
          <div style={{fontSize:10,letterSpacing:"0.05em",textTransform:"uppercase",color:T.faint}}>Spread</div>
          <div style={{...num,fontSize:14,marginTop:3}}>{favAbbr} -{byPts}</div>
          {p.ats_side!=null && <div style={{fontSize:11,marginTop:4,fontWeight:700,color:atsBig?T.green:T.muted}}>Lean {p.ats_side} {p.ats_edge>0?'+':''}{p.ats_edge}</div>}
        </div>
        <div style={{background:T.card2,borderRadius:10,padding:"9px 11px"}}>
          <div style={{fontSize:10,letterSpacing:"0.05em",textTransform:"uppercase",color:T.faint}}>Total</div>
          <div style={{...num,fontSize:14,marginTop:3}}>{p.total}</div>
          {p.ou_side!=null && <div style={{fontSize:11,marginTop:4,fontWeight:700,color:ouBig?T.green:T.muted}}>{p.ou_side} {g.total} {p.ou_edge>0?'+':''}{p.ou_edge}</div>}
        </div>
      </div>
      <div style={{fontSize:10,color:T.faint,marginTop:9,lineHeight:1.4}}>
        Book: {teamNick(g.away.abbr)} {g.spread>0?'+':''}{g.spread} · O/U {g.total} points. Market-anchored — a lean shows only real disagreement.
      </div>
    </div>
  )
}

// ── Attack Map ────────────────────────────────────────────────────────────────
// The headline "where to attack + who to bet" view: each opposing defensive unit shown
// as a soft↔stingy gauge with a verdict (ATTACK / MIDDLING / FADE), and the plays that
// exploit a soft unit nested right under it — so a buried winner (a possession WR's
// receptions) surfaces under the soft coverage lane instead of a flat prob-sorted list.
function AttackLane({ lane, onPlayer }){
  const soft = lane.softness
  const isA = lane.verdict === 'attack', isF = lane.verdict === 'fade'
  const vcol = isA ? T.green : isF ? T.red : T.muted
  const bord = isA ? (T.greenMid || T.green) : isF ? '#4a2730' : T.border
  const bg = isA ? T.greenDim : isF ? '#1a1013' : T.card
  return (
    <div style={{ border: `1px solid ${bord}`, background: bg, borderRadius: 12, padding: 11, marginBottom: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ flex: 'none', width: 96, fontSize: 12, fontWeight: 800, textTransform: 'capitalize', lineHeight: 1.2 }}>{lane.label}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ height: 8, borderRadius: 99, background: 'linear-gradient(90deg,#3a1720,#2a2233 45%,#123c31)', position: 'relative' }}>
            {soft != null && <span style={{ position: 'absolute', top: '50%', left: `${Math.max(3, Math.min(97, soft))}%`, width: 13, height: 13, borderRadius: '50%', transform: 'translate(-50%,-50%)', border: '2px solid #0b0f16', background: vcol }} />}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3, fontSize: 10, color: T.muted2 || T.muted, fontWeight: 700, letterSpacing: '0.04em' }}><span>STINGY</span><span>SOFT</span></div>
        </div>
        <span style={{ flex: 'none', fontSize: 10, fontWeight: 900, letterSpacing: '0.04em', color: vcol, background: isA ? T.greenDim : isF ? '#3a1720' : (T.card2 || T.card), borderRadius: 6, padding: '4px 8px' }}>{isA ? 'ATTACK' : isF ? 'FADE' : 'MIDDLING'}</span>
      </div>
      <div style={{ fontSize: 11, color: T.muted, marginTop: 7, lineHeight: 1.35 }}>{lane.why}</div>
      {lane.plays && lane.plays.length > 0 && (
        <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 5 }}>
          {lane.plays.map((p, i) => {
            const tier = p.tier || tierFromProb((p.prob || 0), p.conf || 0, p.edge_pct, p.prop_type)
            const isTD = p.market === 'Anytime TD'
            const proj = !isTD && p.book_line == null
            return (
              <div key={i} onClick={() => onPlayer && onPlayer(p)} style={{ display: 'flex', alignItems: 'center', gap: 9, background: T.card2 || T.card, border: `1px solid ${T.border}`, borderRadius: 9, padding: '7px 9px', cursor: onPlayer ? 'pointer' : 'default' }}>
                <RatingBadge tier={tier} size={26} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</div>
                  <div style={{ fontSize: 10, color: T.muted }}>{isTD ? 'Anytime TD' : `${playText(p.market, p.line)}`}
                    {proj && <span style={{ marginLeft: 5, fontSize: 10, fontWeight: 800, color: T.amber, background: T.amberDim || 'transparent', border: `1px solid ${T.amber}`, borderRadius: 4, padding: '0 4px' }}>PROJ</span>}
                    {p.edge_pct != null && p.edge_pct >= 3 && <span style={{ marginLeft: 5, color: T.green, fontWeight: 700 }}>+{p.edge_pct.toFixed(0)}%</span>}
                  </div>
                </div>
                <div style={{ flex: 'none', fontSize: 14, fontWeight: 900, fontFamily: T.mono, color: probColor(p.prob || 0) }}>{pct(p.prob || 0)}</div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

function AttackMap({ g, onPlayer }){
  const panels = [
    { off: g.away?.abbr, def: g.home?.abbr, lanes: g.attack?.away, col: T.green },
    { off: g.home?.abbr, def: g.away?.abbr, lanes: g.attack?.home, col: T.green },
  ]
  const has = panels.some(p => p.lanes && p.lanes.length)
  if (!has) return <div style={{ fontSize: 12, color: T.muted, padding: '16px 0', lineHeight: 1.5 }}>No matchup data for this game yet.</div>
  return (
    <div>
      <ExportBtn text={buildGameReport(g)} title={`${g.away?.abbr} @ ${g.home?.abbr} — LINEBRKR attack map`} label="Export attack map" />
      <div style={{ fontSize: 11, color: T.muted, margin: '2px 0 10px', lineHeight: 1.4 }}>
        Where each offense can attack the other's defense — <b style={{ color: T.green }}>ATTACK</b> a soft unit, <b style={{ color: T.red }}>FADE</b> a locked-down one. Plays that exploit a soft unit sit right under it.
      </div>
      {panels.map((pn, i) => (pn.lanes && pn.lanes.length ? (
        <div key={i} style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 14, padding: 12, marginBottom: 12 }}>
          <div style={{ fontSize: 12.5, fontWeight: 900, marginBottom: 10 }}>
            <span style={{ color: pn.col }}>{pn.off} offense</span> <span style={{ color: T.muted }}>vs {pn.def} defense</span>
          </div>
          {pn.lanes.map((l, j) => <AttackLane key={j} lane={l} onPlayer={onPlayer} />)}
        </div>
      ) : null))}
    </div>
  )
}

// Game Plan — the opponent's defensive soft spots (incl. slot vs outside) and the specific
// players who exploit them, as proposed props with the matchup rank as the "why". The automatic
// version of "they're soft to the slot, so play the slot WR."
function GamePlanPanel({ gameId, season, week, onPlayer }){
  const [d,setD] = useState(null)
  const [read,setRead] = useState(null)      // "The Read" — AI 60-sec preview (null if key unset)
  useEffect(()=>{ let a=true; setD(null); setRead(null)
    getNFLGamePlan(gameId, season, week).then(r=>{ if(a) setD(r) })
    getNFLGameRead(gameId, season, week).then(r=>{ if(a && r && r.read) setRead(r.read) })
    return ()=>{a=false} },[gameId,season,week])
  if(!d) return <Spinner/>
  const side = (plan) => {
    if(!plan) return null
    return (
      <div style={{marginBottom:14}}>
        <div style={{fontSize:13.5,fontWeight:800,margin:'12px 0 7px'}}>
          <TeamTag abbr={plan.off} size={20} color={T.green}/> <span style={{color:T.muted,fontWeight:600}}>attack</span> <TeamTag abbr={plan.def} size={20} color={T.text}/>
        </div>
        {/* 60-second brief — coverage scheme + scheme/trend lines */}
        {(plan.brief?.coverage || plan.brief?.trends?.length) ? (
          <div style={{background:T.card2,border:`1px solid ${T.border}`,borderRadius:10,padding:'8px 11px',marginBottom:9}}>
            {plan.brief.coverage && (
              <div style={{fontSize:12,fontWeight:800,marginBottom:plan.brief.trends?.length?5:0}}>
                {teamNick(plan.def)} play <span style={{color:T.green}}>{plan.brief.coverage.label}</span>
                <span style={{color:T.muted,fontWeight:600}}> · {plan.brief.coverage.rate}%{plan.brief.coverage.blitz?` · ${plan.brief.coverage.blitz}% blitz`:''}</span>
              </div>
            )}
            {plan.brief.trends?.length ? (
              <div style={{fontSize:10.5,color:T.muted,lineHeight:1.6}}>
                {plan.brief.trends.map((t,i)=><span key={i}>{i?' · ':''}{nickify(t)}</span>)}
              </div>
            ) : null}
          </div>
        ) : null}
        {plan.soft_spots?.length ? (
          <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:9}}>
            {plan.soft_spots.slice(0,7).map((s,i)=>(
              <span key={i} style={{fontSize:10.5,fontWeight:700,color:T.green,background:T.greenDim,
                border:`1px solid ${T.green}55`,borderRadius:7,padding:'3px 8px',whiteSpace:'nowrap'}}>
                #{s.rank} {s.unit}
              </span>
            ))}
          </div>
        ) : <div style={{fontSize:11,color:T.muted,marginBottom:9}}>No standout soft spots vs the {teamNick(plan.def)} this week.</div>}
        {plan.props?.length ? plan.props.map((p,i)=>(
          <button key={i} onClick={()=>onPlayer && p.gsis_id && onPlayer({gsis_id:p.gsis_id,full_name:p.name,
            name:p.name,pos:p.pos,team:p.team,opp:p.opp,market:p.market,line:p.line,prob_over:p.hit_prob,status:'active'})}
            style={{display:'flex',width:'100%',textAlign:'left',alignItems:'center',gap:9,background:T.card,
            border:`1px solid ${T.border}`,borderRadius:11,padding:'9px 11px',marginBottom:7,cursor:'pointer',color:T.text}}>
            <Avatar url={p.headshot} name={p.name} team={p.team} size={34}/>
            <div style={{minWidth:0,flex:1}}>
              <div style={{fontSize:13.5,fontWeight:800,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                {p.name} <span style={{fontSize:10,color:T.muted,fontWeight:700}}>{p.pos}</span></div>
              <div style={{fontSize:10.5,color:T.muted,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                {p.market==='Anytime TD'?'Anytime TD':`${playText(p.market, p.line)}`}</div>
              <div style={{fontSize:10,color:p.matchup_rank!=null?T.green:T.muted2,marginTop:2,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{p.matchup_rank!=null?'✓ ':'· '}{nickify(p.why)}</div>
            </div>
            <div style={{textAlign:'right',flexShrink:0}}>
              <div style={{fontFamily:T.mono,fontWeight:900,fontSize:15,color:probColor(p.hit_prob||0)}}>{Math.round((p.hit_prob||0)*100)}%</div>
              {p.edge_pct!=null && <div style={{fontFamily:T.mono,fontSize:10,fontWeight:700,color:p.edge_pct>=0?T.green:T.red}}>{p.edge_pct>=0?'+':''}{p.edge_pct.toFixed(1)}%</div>}
            </div>
          </button>
        )) : <div style={{fontSize:11,color:T.muted,marginBottom:8}}>No proposed props here yet — thin board or no soft matchups.</div>}
      </div>
    )
  }
  return (
    <div style={{paddingTop:6}}>
      <div style={{fontSize:11,color:T.muted,lineHeight:1.5,marginBottom:2}}>
        Where each offense can attack the other's defense — the opponent's softest units (incl.
        <b style={{color:T.text}}> slot vs outside</b>) and the players who exploit them. Tap a play for the full breakdown. Research, not advice.
      </div>
      {read && (
        <div style={{background:T.greenDim,border:`1px solid ${T.green}55`,borderRadius:11,padding:'11px 13px',margin:'10px 0 4px'}}>
          <div style={{fontSize:11,fontWeight:800,color:T.green,letterSpacing:'0.04em',marginBottom:5}}>📋 THE READ · 60-SECOND PREVIEW</div>
          <div style={{fontSize:12.5,color:T.text,lineHeight:1.6,whiteSpace:'pre-wrap'}}>{read}</div>
        </div>
      )}
      {side(d.plans?.away)}
      {side(d.plans?.home)}
      {((d.plans?.away?.props?.length) || (d.plans?.home?.props?.length)) ? (
        <button onClick={()=>shareNflMatchupPlan(gameId, season, week)} style={{display:'block',width:'100%',
          marginTop:4,padding:'10px 0',background:T.card,border:`1px solid ${T.border}`,borderRadius:10,
          color:T.green,fontWeight:800,fontSize:12.5,cursor:'pointer'}}>
          📤 Export game plan
        </button>
      ) : null}
    </div>
  )
}

// Week at a Glance — a swipeable flash-card deck, one card per game, each a 30-second rundown
// (matchup + coverage scheme + soft spots + the model's top players to watch). Tap a card to open
// the full game breakdown. Cards lazy-load their game-plan as you swipe to them.
function GlanceCard({ game, plan, read, onOpen }){
  const g = game
  const spr = g.spread
  const chipLine = (p) => p ? (
    <div style={{ marginBottom:10 }}>
      <div style={{ fontSize:12, fontWeight:800, marginBottom:4 }}>
        <TeamTag abbr={p.off} size={16} color={T.green}/> <span style={{ color:T.muted, fontWeight:600 }}>attack</span> <TeamTag abbr={p.def} size={16} color={T.text}/>
        {p.brief?.coverage && <span style={{ color:T.muted, fontWeight:600 }}> · {teamNick(p.def)} {p.brief.coverage.label} {p.brief.coverage.rate}%</span>}
      </div>
      {p.soft_spots?.length ? (
        <div style={{ display:'flex', flexWrap:'wrap', gap:5 }}>
          {p.soft_spots.slice(0,5).map((s,i)=>(
            <span key={i} style={{ fontSize:10, fontWeight:700, color:T.green, background:T.greenDim,
              border:`1px solid ${T.green}55`, borderRadius:6, padding:'2px 7px', whiteSpace:'nowrap' }}>#{s.rank} {s.unit}</span>
          ))}
        </div>
      ) : null}
      {(p.props||[]).slice(0,2).map((r,i)=>(
        <div key={i} style={{ fontSize:11, color:T.text, marginTop:4, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
          • <b>{r.name}</b> <span style={{ color:T.muted }}>{r.market==='Anytime TD'?'ATD':`${playText(r.market, r.line)}`}</span> <span style={{ color:playColor(r.hit_prob||0, r), fontFamily:T.mono, fontWeight:700 }}>{Math.round((r.hit_prob||0)*100)}%</span></div>
      ))}
    </div>
  ) : null
  return (
    <div style={{ height:'100%', overflowY:'auto', WebkitOverflowScrolling:'touch',
      background:T.card, border:`1px solid ${T.border}`, borderRadius:16, padding:16, boxSizing:'border-box' }}>
      <div style={{ marginBottom:2 }}>{g.away?.abbr && g.home?.abbr
        ? <GameLogos away={g.away.abbr} home={g.home.abbr} size={32} names color={T.text}/>
        : <span style={{ fontSize:20, fontWeight:900 }}>{g.away?.abbr||'—'} @ {g.home?.abbr||'—'}</span>}</div>
      <div style={{ fontSize:11.5, color:T.muted, marginBottom:12 }}>
        {g.day} {g.time}{spr!=null?` · ${teamNick(g.home?.abbr)} ${(-spr>0?'+':'')+(-spr)}`:''}{g.total!=null?` · O/U ${g.total}`:''}</div>
      {/* THE READ — the headline of each card (Mikey's ask: full-screen, the green square per game).
          read === undefined → still generating (lazy per-card fetch; the Haiku call takes a few
          seconds), so show a WRITING state instead of a blank gap that looks broken. read === null →
          genuinely off/failed, render nothing and let the structured rundown stand on its own.
          (Never surface the raw env-var name to users; owners confirm AI status via /nfl/admin/ai-check.) */}
      {read === undefined ? (
        <div style={{ background:T.greenDim, border:`1px solid ${T.green}33`, borderRadius:12, padding:'12px 14px', marginBottom:12 }}>
          <div style={{ fontSize:11, fontWeight:800, color:T.green, letterSpacing:'0.04em', marginBottom:6 }}>✍️ THE READ · 60-SECOND PREVIEW</div>
          <div style={{ display:'flex', gap:6 }}>
            {[0,1,2].map(i=>(
              <span key={i} style={{ width:7, height:7, borderRadius:999, background:T.green, opacity:0.4,
                animation:`glanceDot 1s ${i*0.15}s infinite ease-in-out` }}/>
            ))}
            <span style={{ fontSize:12, color:T.muted, fontWeight:600, marginLeft:4 }}>Writing the read…</span>
          </div>
          <style>{`@keyframes glanceDot{0%,80%,100%{opacity:.3}40%{opacity:1}}`}</style>
        </div>
      ) : read ? (
        <div style={{ background:T.greenDim, border:`1px solid ${T.green}55`, borderRadius:12, padding:'12px 14px', marginBottom:12 }}>
          <div style={{ fontSize:11, fontWeight:800, color:T.green, letterSpacing:'0.04em', marginBottom:6 }}>📋 THE READ · 60-SECOND PREVIEW</div>
          <div style={{ fontSize:13, color:T.text, lineHeight:1.62, whiteSpace:'pre-wrap' }}>{read}</div>
        </div>
      ) : null}
      {!plan ? <div style={{ padding:'24px 0', textAlign:'center' }}><Spinner/></div> : (<>
        {chipLine(plan.plans?.away)}
        {chipLine(plan.plans?.home)}
        {!(plan.plans?.away || plan.plans?.home) && <div style={{ fontSize:11, color:T.muted }}>Rundown fills in once the board and lines post.</div>}
      </>)}
      <button onClick={onOpen} style={{ display:'block', width:'100%', textAlign:'center', cursor:'pointer',
        marginTop:8, padding:'11px 0', background:T.card2 || T.card, border:`1px solid ${T.green}`, borderRadius:10,
        color:T.green, fontWeight:800, fontSize:13 }}>Open full breakdown →</button>
    </div>
  )
}

export function WeekAtAGlance({ season, week, games, onClose, onGame }){
  // Swipe in GAME ORDER — earliest kickoff first (Thu → Sun early/late → SNF → MNF). kickoff is
  // an ISO datetime (ET), so a string compare is chronological; games missing a kickoff sort last.
  const _kc = (a,b)=>{ const ka=a.kickoff||a.gameday||'', kb=b.kickoff||b.gameday||''
    return ka===kb?0:!ka?1:!kb?-1:(ka<kb?-1:1) }
  const list = (games||[]).filter(g=>g.game_id).slice()
    .sort((a,b)=> ((a.state==='final')-(b.state==='final')) || _kc(a,b))
  const [idx,setIdx] = useState(0)
  const [cache,setCache] = useState({})     // game_id -> game-plan
  const [reads,setReads] = useState({})     // game_id -> "The Read" text
  const active = list[idx]
  useEffect(()=>{ if(!active) return
    let a=true
    const gid = active.game_id
    if(!cache[gid]) getNFLGamePlan(gid, season, week).then(r=>{ if(a) setCache(c=>({ ...c, [gid]: r })) })
    if(reads[gid]===undefined) getNFLGameRead(gid, season, week).then(r=>{ if(a) setReads(m=>({ ...m, [gid]: (r && r.read) || null })) })
    return ()=>{a=false}
  },[idx, active, season, week])   // eslint-disable-line
  const onScroll = (e)=>{ const w = e.target.clientWidth||1; const i = Math.round(e.target.scrollLeft / w); if(i!==idx && i>=0 && i<list.length) setIdx(i) }
  return (
    <Sheet onClose={onClose}>
      <div style={{ padding:'8px 0 10px' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'4px 16px 4px' }}>
          <div style={{ fontSize:17, fontWeight:900 }}>📋 Week {week} at a glance</div>
          <div style={{ fontSize:12, color:T.muted, fontFamily:T.mono }}>{list.length?`${idx+1} / ${list.length}`:''}</div>
        </div>
        <div style={{ fontSize:11, color:T.muted, padding:'0 16px 10px' }}>Swipe game to game · tap a card for the full breakdown.</div>
        {!list.length ? (
          <div style={{ padding:'24px 16px', color:T.muted, fontSize:13 }}>No games scheduled for Week {week}.</div>
        ) : (
          <div onScroll={onScroll} style={{ display:'flex', overflowX:'auto', scrollSnapType:'x mandatory', WebkitOverflowScrolling:'touch', height:'74vh' }}>
            {list.map(g=>(
              <div key={g.game_id} style={{ flex:'0 0 100%', scrollSnapAlign:'center', padding:'0 16px', height:'100%', boxSizing:'border-box' }}>
                <GlanceCard game={g} plan={cache[g.game_id]} read={reads[g.game_id]} onOpen={()=>{ onGame && onGame(g); onClose && onClose() }}/>
              </div>
            ))}
          </div>
        )}
      </div>
    </Sheet>
  )
}

// "Bet on Kalshi" handoff — opens Kalshi to place the bet THERE (research + handoff only;
// no money/credentials touch the app). Self-hides when the handoff is disabled server-side.
function KalshiBetButton({ gameId, season, week, team }){
  const [link, setLink] = useState(null)
  useEffect(()=>{ let a=true; getKalshiLink(gameId, season, week, team).then(r=>{ if(a) setLink(r) }); return ()=>{a=false} },[gameId,season,week,team])
  if(!link || !link.enabled || !link.url) return null
  return (
    <a href={link.url} target="_blank" rel="noopener noreferrer" style={{ display:'flex', alignItems:'center',
      justifyContent:'center', gap:8, width:'100%', boxSizing:'border-box', textDecoration:'none',
      background:'transparent', color:T.muted2, border:`1px solid ${T.border2}`, fontWeight:800, fontSize:12.5, borderRadius:10,
      padding:'9px 14px', margin:'10px 0 2px' }}>
      <span>◆ {link.exact_market ? 'See this game on Kalshi ↗' : 'View on Kalshi ↗'}</span>
    </a>
  )
}

// Best bets BY CATEGORY — a one-glance summary at the top of a game: the model's game-line lean plus
// the single best player prop in each lane (lock / value / TD), computed from the game's own plays +
// outcome projection. The scannable "what are the plays here" before the detailed breakdown. Tap a
// row to open that player. Research only — it names the model's reads, never a stake.
function GameBestBets({ g, onPlayer }){
  const plays = [...(g.topPlaysAway||[]), ...(g.topPlaysHome||[])]
  const proj = g.proj
  if(!plays.length && !proj) return null
  const byProb = [...plays].sort((a,b)=>(b.prob||0)-(a.prob||0))
  const lock = byProb[0]
  const value = plays.filter(p=>p.edge_pct!=null).sort((a,b)=>b.edge_pct-a.edge_pct)[0]
  const td = byProb.find(p=>p.prop_type==='anytime_td')
  let line=null
  if(proj){
    if(proj.ats_side){
      const sp = proj.ats_side===g.home?.abbr ? (g.spread!=null?-g.spread:null) : g.spread
      line = `${teamNick(proj.ats_side)}${sp!=null?` ${sp>0?'+':''}${sp}`:''}`
    } else if(proj.home_win_prob!=null){
      line = `${teamNick(proj.home_win_prob>=0.5 ? g.home?.abbr : g.away?.abbr)} to win`
    }
    if(proj.ou_edge!=null && Math.abs(proj.ou_edge)>=1.5 && g.total!=null)
      line = `${line?line+' · ':''}${proj.ou_edge>0?'Over':'Under'} ${g.total} points`
  }
  const pct = p => p && p.prob!=null ? `${Math.round(p.prob*100)}%` : ''
  const open = p => p && onPlayer && onPlayer({ full_name:p.name, pos:p.pos, team:p.team, opp:p.opp,
    prop_type:p.prop_type, market:p.market, ...(p.gsis_id?{gsis_id:p.gsis_id}:{}), status:'active' })
  const mkt = p => `${p.name} · ${playText(p.prop_type || p.market, p.line)}`
  const Row = ({icon,label,main,sub,color,onClick}) => (
    <button onClick={onClick} disabled={!onClick} style={{display:'flex',alignItems:'center',gap:10,width:'100%',
      textAlign:'left',cursor:onClick?'pointer':'default',background:T.card2||T.card,border:`1px solid ${T.border}`,
      borderRadius:10,padding:'9px 11px',color:T.text}}>
      <span style={{fontSize:15,width:20,textAlign:'center',flexShrink:0}}>{icon}</span>
      <span style={{minWidth:0,flex:1}}>
        <span style={{display:'block',fontSize:10,fontWeight:800,color:T.faint,letterSpacing:'.05em'}}>{label}</span>
        <span style={{display:'block',fontSize:13.5,fontWeight:800,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{main}</span>
      </span>
      {sub && <span style={{fontFamily:T.mono,fontSize:15,fontWeight:900,color,flexShrink:0}}>{sub}</span>}
    </button>
  )
  return (
    <div style={{background:T.card,border:`1px solid ${(T.greenMid||T.green)}55`,borderRadius:13,padding:'11px 12px',marginTop:10}}>
      <div style={{fontSize:11,fontWeight:800,color:T.green,letterSpacing:'.06em',marginBottom:8}}>⭐ TOP READS · BY CATEGORY</div>
      <div style={{display:'flex',flexDirection:'column',gap:7}}>
        {line && <Row icon="🧱" label="GAME LINE · model lean" main={line} />}
        {lock && <Row icon="🔒" label="MOST LIKELY · highest chance to hit" main={mkt(lock)} sub={pct(lock)} color={probColor(lock.prob||0)} onClick={()=>open(lock)} />}
        {value && value.edge_pct>0 && value!==lock && <Row icon="💎" label="BEST VALUE · model beats the price" main={mkt(value)} sub={`+${value.edge_pct}`} color={T.green} onClick={()=>open(value)} />}
        {td && td!==lock && <Row icon="🏈" label="TOP TD" main={td.name} sub={pct(td)} color={tdColor(td.prob||0)} onClick={()=>open(td)} />}
      </div>
    </div>
  )
}

// FanDuel-style game-lines board — the three core team markets (spread / total / moneyline) as a
// grid of odds buttons, one row per team, with our model's lean highlighted. Pulls the priced
// consensus from /nfl/market; renders nothing until a game has posted odds. Research only — it shows
// the number and our lean, never a stake.
function GameBetsBoard({ game, season, week, proj }){
  const [m,setM] = useState(null)
  useEffect(()=>{ let a=true
    getNFLMarket(season,week).then(r=>{ if(!a) return
      const hit=(r.games||[]).find(x=>x.game_id===game.game_id); setM(hit||false) })
    return ()=>{a=false} },[game.game_id,season,week])
  if(!m) return null
  const sp=m.spread||{}, tot=m.total||{}, ml=m.moneyline||{}
  const away=game.away?.abbr||'AWY', home=game.home?.abbr||'HOM'
  const sgn=v=> v==null?'—':(v>0?`+${v}`:`${v}`)
  const odds=v=> v==null?'':(v>0?`+${v}`:`${v}`)
  const homeSp=sp.current, awaySp=homeSp!=null?-homeSp:null
  // our model's leans (null-safe): ML favorite, ATS side, O/U lean
  const favHome = proj && proj.home_win_prob!=null ? proj.home_win_prob>=0.5 : null
  const atsPick = proj && proj.ats_side ? proj.ats_side : null
  const ouPick = proj && proj.ou_edge!=null ? (proj.ou_edge>0?'over':'under') : null
  const Cell=({big,small,pick})=>(
    <div style={{background:pick?T.greenDim:(T.card2||T.card),border:`1px solid ${pick?T.green:T.border}`,
      borderRadius:9,padding:'7px 4px',textAlign:'center',minWidth:0}}>
      <div style={{fontSize:13,fontWeight:800,fontFamily:T.mono,color:pick?T.green:T.text,whiteSpace:'nowrap'}}>{big}</div>
      {small!==''&&small!=null && <div style={{fontSize:10,fontFamily:T.mono,color:T.muted,marginTop:1}}>{small}</div>}
    </div>
  )
  const Row=({team,isHome})=>(
    <div style={{display:'grid',gridTemplateColumns:'50px 1fr 1fr 1fr',gap:6,alignItems:'stretch',marginBottom:6}}>
      <div style={{display:'flex',alignItems:'center',fontSize:14,fontWeight:900}}>{team}</div>
      <Cell big={sgn(isHome?homeSp:awaySp)} small={odds(isHome?sp.home_odds:sp.away_odds)}
        pick={atsPick===team}/>
      <Cell big={tot.current!=null?`${isHome?'U':'O'} ${tot.current}`:'—'} small={odds(isHome?tot.under_odds:tot.over_odds)}
        pick={ouPick===(isHome?'under':'over')}/>
      <Cell big={odds(isHome?ml.home:ml.away)||'—'} small=''
        pick={favHome!=null && (isHome?favHome:!favHome)}/>
    </div>
  )
  return (
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:13,padding:'12px 13px',marginBottom:12}}>
      <div style={{display:'grid',gridTemplateColumns:'50px 1fr 1fr 1fr',gap:6,marginBottom:7}}>
        <div/>
        {['SPREAD','TOTAL','MONEYLINE'].map(h=>(
          <div key={h} style={{fontSize:10,fontWeight:800,color:T.muted,letterSpacing:'0.05em',textAlign:'center'}}>{h}</div>
        ))}
      </div>
      <Row team={away} isHome={false}/>
      <Row team={home} isHome={true}/>
      <div style={{fontSize:10,color:T.faint,marginTop:4,display:'flex',alignItems:'center',gap:6,lineHeight:1.4}}>
        <span style={{width:9,height:9,borderRadius:3,background:T.greenDim,border:`1px solid ${T.green}`,flexShrink:0}}/>
        LINEBRKR model lean · consensus of {m.books} book{m.books===1?'':'s'} · research only, not a wager
      </div>
    </div>
  )
}

export function GameModal({ game, season, week, onClose, onPlayer }){
  const [tab,setTab] = useState('Plan')
  const [d,setD] = useState(null)
  useEffect(()=>{ let a=true
    getNFLGame(game.game_id, season, week).then(r=>{ if(a) setD(r) })
    return ()=>{a=false} },[game.game_id,season,week])

  const g = { ...game, ...(d||{}) }          // detail overrides slate; header renders immediately
  const indoor = g.roof==='dome' || g.roof==='closed'
  const spr = g.spread
  const homeLine = spr!=null ? (-spr>0?'+':'')+(-spr) : ''

  return (
    <Sheet onClose={onClose}>
      <div style={{padding:"8px 16px 22px"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:6}}>
          <div>
            {/* Null-safe: a tap from the Cheatsheet / Signals passes only {game_id}, so
                away/home aren't present until the fetch resolves — never crash the header. */}
            {g.away?.abbr && g.home?.abbr
              ? <div style={{marginBottom:4}}><GameLogos away={g.away.abbr} home={g.home.abbr} size={34} names color={T.text}/></div>
              : <div style={{fontSize:20,fontWeight:900}}>—</div>}
            <div style={{fontSize:12,color:T.muted}}>{g.day} {g.time}{spr!=null?` · ${teamNick(g.away?.abbr)} ${spr>0?'+':''}${spr} · ${teamNick(g.home?.abbr)} ${homeLine}`:''}{g.total!=null?` · O/U ${g.total} (points expected)`:''}</div>
          </div>
          <div style={{textAlign:'center',flexShrink:0}}>
            <GradeRing grade={g.grade} size={52}/>
            <div style={{fontSize:10,fontWeight:800,color:T.muted,letterSpacing:'.08em',marginTop:2}}>ACTION</div>
          </div>
        </div>

        <KalshiBetButton gameId={game.game_id} season={season} week={week}/>

        {/* Best bets by category — the one-glance summary above the detailed breakdown */}
        <GameBestBets g={g} onPlayer={onPlayer}/>

        <Tabs tabs={['Plan','Attack','Matchup','Plays','Env']} active={tab} onSelect={t=>{ track('game_tab', t); setTab(t) }}/>

        {tab==='Plan' && <GamePlanPanel gameId={game.game_id} season={season} week={week} onPlayer={onPlayer}/>}

        {tab==='Attack' && (!d ? <Spinner/> : d._sample ? (
          <div style={{fontSize:12,color:T.muted,padding:"16px 0",lineHeight:1.5}}>
            Live game analytics are unavailable right now — check back shortly.
          </div>
        ) : (
          <AttackMap g={g} onPlayer={onPlayer}/>
        ))}

        {tab==='Matchup' && (!d ? <Spinner/> : d._sample ? (
          <div style={{fontSize:12,color:T.muted,padding:"16px 0",lineHeight:1.5}}>
            Live game analytics are unavailable right now — check back shortly.
          </div>
        ) : (
          <div>
            {/* Export the whole game report — the read + top plays + scorers — to any app */}
            <ExportBtn text={buildGameReport(g)} title={`${g.away?.abbr} @ ${g.home?.abbr} — LINEBRKR read`} />
            {/* The read — a plain-English guide rail synthesizing environment + where to attack */}
            {Array.isArray(d.read) && d.read.length > 0 && (
              <div style={{ background: T.greenDim, border: `1px solid ${T.greenMid||T.green}55`, borderRadius: 12,
                padding: "11px 13px", marginBottom: 12 }}>
                <div style={{ fontSize: 10.5, fontWeight: 800, color: T.green, letterSpacing: "0.05em",
                  textTransform: "uppercase", marginBottom: 6 }}>The read</div>
                {d.read.map((line, i) => (
                  <div key={i} style={{ display: "flex", gap: 7, marginBottom: i < d.read.length-1 ? 5 : 0,
                    fontSize: 12.5, color: T.text, lineHeight: 1.45 }}>
                    <span style={{ color: T.green, flexShrink: 0 }}>›</span><span>{line}</span>
                  </div>
                ))}
              </div>
            )}
            {/* How our model sees it — leads with our outcome model vs the book */}
            <GameModelBlock g={g}/>
            {/* Implied points + pace + pressure */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:10}}>
              <Stat label={`${g.away.abbr} implied pts`} value={g.implied?.away ?? '—'} color={T.text}/>
              <Stat label={`${g.home.abbr} implied pts`} value={g.implied?.home ?? '—'} color={T.text}/>
              <Stat label="Pace (plays/g)" value={g.pace ? `${g.pace.away ?? '—'} · ${g.pace.home ?? '—'}` : '—'}/>
              <Stat label="Pass rush (QB-hit%)" value={g.pressure ? `${g.pressure.away!=null?Math.round(g.pressure.away*100):'—'} · ${g.pressure.home!=null?Math.round(g.pressure.home*100):'—'}` : '—'}/>
            </div>

            <div style={{fontSize:11,color:T.muted,margin:"6px 0 6px",fontWeight:700,letterSpacing:"0.02em"}}>Where to attack <span style={{color:T.faint,fontWeight:400}}>· <b style={{color:T.green}}>ATTACK</b> = opponent is soft vs that unit</span></div>
            <EdgePanel off={g.away.abbr} def={g.home.abbr} rows={g.edges?.away}/>
            <EdgePanel off={g.home.abbr} def={g.away.abbr} rows={g.edges?.home}/>

            {(g.scorers?.away?.length || g.scorers?.home?.length) ? (
              <>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,margin:"10px 0 6px"}}>
                  <div style={{fontSize:11,color:T.muted,fontWeight:700,letterSpacing:"0.02em"}}>Most likely to score <span style={{color:T.faint,fontWeight:400}}>· anytime TD, ranked by the opponent's scoring weakness</span></div>
                  <ScorerCopyBtn text={buildScorerText(g)}/>
                </div>
                <ScorerPanel off={g.away.abbr} rows={g.scorers?.away}/>
                <ScorerPanel off={g.home.abbr} rows={g.scorers?.home}/>
              </>
            ) : null}

            {(g.redzone?.away!=null || g.redzone?.home!=null) && (
              <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,margin:"2px 0 10px"}}>
                <Stat label={`${g.away.abbr} RZ TD rate allowed`} value={g.redzone?.away!=null?`${Math.round(g.redzone.away*100)}%`:'—'}/>
                <Stat label={`${g.home.abbr} RZ TD rate allowed`} value={g.redzone?.home!=null?`${Math.round(g.redzone.home*100)}%`:'—'}/>
              </div>
            )}

            <DefImpact away={g.away.abbr} home={g.home.abbr} data={g.def_impact}/>
            <InjuryList team={g.away.abbr} list={g.injuries?.away}/>
            <InjuryList team={g.home.abbr} list={g.injuries?.home}/>
            {(() => {
              const srcs = [d.defense_source_season, d.pace_source_season, d.redzone_source_season]
                .filter(x => x && x !== season)
              return srcs.length ? <div style={{fontSize:10,color:T.muted,lineHeight:1.5}}>
                Matchup data carried over from {Math.max(...srcs)} — it does not yet account for this year's coaching, roster, or scheme changes, and sharpens as the {season} season is played.
              </div> : null
            })()}
          </div>
        ))}

        {tab==='Plays' && (
          <div>
            {/* FanDuel-style game lines — spread / total / moneyline for both teams, our lean marked */}
            <GameBetsBoard game={g} season={season} week={week} proj={g.proj}/>
            <div style={{fontSize:11,color:T.muted,marginBottom:8}}>
              {g.bestBets||0} strong {g.bestBets===1?'play':'plays'} · {g.plays||0} projected
            </div>
            {!d ? <Spinner/> : (d._sample ? (game.topPlays?.length
              ? <PlaysList label="Top plays" plays={game.topPlays}/>
              : <div style={{fontSize:12,color:T.muted}}>No qualified plays available right now.</div>)
            : (<>
              <PlaysList label={`${g.away.abbr} plays`} plays={g.topPlaysAway}/>
              <PlaysList label={`${g.home.abbr} plays`} plays={g.topPlaysHome}/>
            </>))}
          </div>
        )}

        {tab==='Env' && (
          <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8}}>
            <Stat label="Roof" value={indoor?'Indoor':'Outdoor'} color={indoor?T.blue:T.amber}/>
            <Stat label="Surface" value={g.surface}/>
            <Stat label="Total" value={g.total}/>
            <Stat label="Env grade" value={g.env} color={gradeColor(g.env)}/>
            {g.weather && <>
              <Stat label="Wind" value={`${g.weather.wind_mph} mph`} color={g.weather.wind_mph>=15?T.amber:T.text}/>
              <Stat label="Temp" value={`${g.weather.temp_f}°F`}/>
              <Stat label="Precip" value={g.weather.precip>0?`${g.weather.precip}"`:'none'}/>
              <Stat label="Passing impact" value={`${Math.round((g.weather.pass_impact-1)*100)}%`} color={g.weather.pass_impact<0.97?T.amber:T.text}/>
            </>}
            <div style={{gridColumn:"1 / -1",fontSize:11,color:T.muted}}>{g.stadium}{!indoor && !g.weather && ' · weather lands closer to kickoff'}</div>
          </div>
        )}
      </div>
    </Sheet>
  )
}

// ── Owner Ops panel ──────────────────────────────────────────────────────────
// One-tap pipeline controls, so the owner can run the daily/weekly jobs from a
// phone without pasting admin URLs or keys. Every call authorizes with the code
// the owner is already logged in with; the backend rejects beta codes, so this is
// a safe no-op for anyone but the owner.
const OPS_JOBS = [
  ['backfill', 'Load history (game logs)', 'Backfill 2024–25 game logs — the projection base. Run this if players are MISSING from the board. ~2–4 min.'],
  ['rosters', 'Refresh rosters', 'Pull current-season rosters + depth charts (trades / signings / cuts). ~15s.'],
  ['rollover', 'Run full pipeline', 'Rosters → depth charts → project all markets → odds → season futures. ~1–2 min.'],
  ['pull_lines', 'Pull book lines', 'Live odds across every US book → best-price line shopping + edges. ~30–60s.'],
  ['epa', 'Compute team EPA', 'Team EPA / success / explosive rates from play-by-play — powers the Matchup Matrix grades (current season). ~1–2 min.'],
  ['live', 'Live update (in-game)', 'Pull in-game player stats from ESPN so the This Week card locks live hits. Auto-runs every 2 min during games; tap to force one now.'],
  ['validate', 'Run backtest (2022–25)', 'Grade every market against four seasons of results.'],
  ['fantasy_backtest', 'Run fantasy accuracy', 'Grade projected vs actual fantasy points (MAE + rank accuracy) over past seasons.'],
  ['fit_calibration', 'Refit calibration', 'Re-tune the probability curves from settled results.'],
  ['tune_td', 'Tune anytime-TD', 'Sweep the TD share-concentration over the backtest and report the sharpest setting. ~2–4 min · read the result in Recent jobs.'],
]

// Post-card generator for the NFL Ops panel — the NFL analog of the MLB Daily Post Cards.
// One tap builds a branded PNG from the LIVE board and hands it to the share sheet (or
// downloads on desktop). No export, no design tool — pull the whole social drop from admin.
function NflPostCards({ season, week }) {
  const [busy, setBusy] = useState('')
  const [msg, setMsg] = useState('')
  const CARDS = [
    ['thu',   '🌙 Thursday Night', () => shareNflThursday(season, week)],
    ['top10', '🏈 Top 10 Board',   () => shareNflTop10(season, week)],
    ['td',    '🎯 Anytime TD',     () => shareNflMarket('anytime_td', season, week)],
    ['plan',  '📋 Game Plan',      () => shareNflGameplan(season, week)],
    ['paydirt', '🏈 Pay Dirt',     () => shareNflPaydirt(season, week)],
    ['spots', '📈 Matchup Spots',  () => shareNflSpots(season, week)],
    ['recap', '📊 Week Recap',     () => shareNflRecap(season, week)],
  ]
  const one = (key, fn) => async () => {
    if (busy) return
    setBusy(key); setMsg('')
    try { await fn() } catch (_) { setMsg('Card failed — try again in a moment.') }
    setBusy('')
  }
  const all = async () => {
    if (busy) return
    setBusy('all'); setMsg('')
    for (const [, , fn] of CARDS) { try { await fn() } catch (_) {} }
    setBusy(''); setMsg('Ran the whole drop — one share/download per card.')
  }
  return (
    <div style={{ background: T.card2, border: `1px solid ${T.border}`, borderRadius: 11, padding: '12px 14px', marginBottom: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 800, color: T.text, marginBottom: 3 }}>🖼️ Post Cards — one-tap social set</div>
      <div style={{ fontSize: 10.5, color: T.muted, lineHeight: 1.5, marginBottom: 10 }}>
        Branded graphics built from the live board — each opens the share sheet (downloads on desktop). Same as baseball: <b style={{ color: T.text }}>pull the whole drop yourself, no export.</b>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 8 }}>
        {CARDS.map(([key, label, fn]) => (
          <button key={key} onClick={one(key, fn)} disabled={!!busy} style={{ padding: '10px 8px', borderRadius: 9, cursor: busy ? 'default' : 'pointer',
            fontSize: 12, fontWeight: 800, border: `1px solid ${T.border2}`, background: T.card, color: busy === key ? T.green : T.text,
            opacity: busy && busy !== key ? 0.5 : 1 }}>{busy === key ? 'Building…' : label}</button>
        ))}
      </div>
      <button onClick={all} disabled={!!busy} style={{ width: '100%', marginTop: 8, padding: '10px 0', borderRadius: 9, cursor: busy ? 'default' : 'pointer',
        fontSize: 12.5, fontWeight: 800, border: 'none', background: T.green, color: '#04140C', opacity: busy ? 0.6 : 1 }}>
        {busy === 'all' ? 'Generating the drop…' : '⚡ Generate all'}
      </button>
      {msg && <div style={{ fontSize: 11, color: T.muted2, marginTop: 8 }}>{msg}</div>}
    </div>
  )
}

// Referrals (owner) — the in-app view of the referral program: who's referred paying
// subscribers, how much each has earned ($20 per 5 who stay a paid month), what's owed,
// a one-tap "mark paid" (logs a hand payout so owed drops), and a box to mint a named
// code (CJ01 / CRAIG01 / DCHOA01). Reads cross-sport data; owner-authed via the ops key.
function ReferralsOps() {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState(null)      // null=unloaded, {}=loading
  const [newCode, setNewCode] = useState('')
  const [newLabel, setNewLabel] = useState('')
  const [msg, setMsg] = useState('')
  const load = async () => { setData({}); setData(await getNFLReferralsAdmin()) }
  const openIt = () => { if (!open) { setOpen(true); load() } else setOpen(false) }
  const create = async () => {
    const c = newCode.trim(); if (!c) return
    setMsg('Creating…')
    const r = await nflMakeRefCode(c, newLabel.trim())
    if (r.ok) { setMsg(`✓ ${r.display || c} ready — share linebrkr.app/?ref=${r.code}`); setNewCode(''); setNewLabel(''); load() }
    else setMsg(`✕ ${r.detail || 'Could not create'}`)
  }
  const markPaid = async (t) => {
    const def = t.owed > 0 ? t.owed : t.earned
    const amt = window.prompt(`Log a payment to "${t.ref_code}" (owed $${t.owed}). Amount in $:`, String(def))
    if (amt == null) return
    const n = parseFloat(amt); if (!(n > 0)) return
    const note = window.prompt('Note (how paid)? optional:', 'venmo') || ''
    setMsg('Logging…')
    const r = await nflReferralPayout(t.ref_code, n, note)
    setMsg(r.ok ? `✓ Logged $${r.logged} to ${t.ref_code} — now owes $${r.owed}` : `✕ ${r.detail || 'Failed'}`)
    load()
  }
  // Credit a referral by hand — for someone who used a code off-app (word of mouth).
  const addManual = async () => {
    const rc = (window.prompt('Credit a referral to which code? (e.g. CJ01)') || '').trim()
    if (!rc) return
    const nm = (window.prompt(`Who did ${rc.toUpperCase()} refer? (name)`) || '').trim()
    if (!nm) return
    const q = window.confirm(`Did ${nm} join and stay a paid month? OK = yes (counts toward $20), Cancel = pending.`)
    setMsg('Adding…')
    const r = await nflAttributeReferral(rc, nm, q)
    setMsg(r.ok ? `✓ Credited ${r.added} to ${r.code} — ${r.total_qualified} qualified, $${r.earned} earned` : `✕ ${r.detail || 'Failed'}`)
    load()
  }
  const refs = (data && data.referrers) || []
  const owed = (data && data.total_owed) || 0
  const err = data && data._error
  const th = { textAlign: 'right', padding: '6px 6px', fontSize: 10, color: T.muted, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }
  const td = { textAlign: 'right', padding: '7px 6px', fontFamily: T.mono, fontSize: 12, whiteSpace: 'nowrap' }
  return (
    <div style={{ background: T.card, border: `1px solid ${T.border2}`, borderRadius: 12, padding: '12px 13px', marginBottom: 14 }}>
      <button onClick={openIt} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, background: 'none', border: 'none', color: T.text, cursor: 'pointer', padding: 0 }}>
        <span style={{ fontSize: 14, fontWeight: 900 }}>🎁 Referrals{owed > 0 ? <span style={{ color: T.green, fontWeight: 800, fontSize: 12 }}> · ${owed} owed</span> : null}</span>
        <span style={{ color: T.muted2, fontSize: 12 }}>{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 10.5, color: T.muted, lineHeight: 1.45, marginBottom: 10 }}>
            $20 for every 5 referrals who stay a paid month. <b style={{ color: T.text }}>Qualified</b> = past their first paid month (live from Stripe). Tap a row to log a payment.
          </div>
          {/* Mint a named code */}
          <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
            <input value={newCode} onChange={e => setNewCode(e.target.value)} placeholder="New code (e.g. CJ01)"
              autoCapitalize="characters" autoCorrect="off" spellCheck={false}
              style={{ flex: 1, minWidth: 0, boxSizing: 'border-box', padding: '9px 10px', fontSize: 12.5, background: T.card2, color: T.text, border: `1px solid ${T.border}`, borderRadius: 8, letterSpacing: '0.04em' }} />
            <input value={newLabel} onChange={e => setNewLabel(e.target.value)} placeholder="Name"
              style={{ width: 86, boxSizing: 'border-box', padding: '9px 10px', fontSize: 12.5, background: T.card2, color: T.text, border: `1px solid ${T.border}`, borderRadius: 8 }} />
            <button onClick={create} disabled={!newCode.trim()} style={{ flexShrink: 0, padding: '0 14px', borderRadius: 8, cursor: newCode.trim() ? 'pointer' : 'default', fontSize: 12.5, fontWeight: 800, border: 'none', background: T.green, color: '#04140D', opacity: newCode.trim() ? 1 : 0.5 }}>Create</button>
          </div>
          <button onClick={addManual} style={{ width: '100%', marginBottom: 8, padding: '9px 0', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 800, border: `1px solid ${T.border}`, background: T.card2, color: T.green }}>+ Credit a referral by hand</button>
          {msg && <div style={{ fontSize: 11, color: msg[0] === '✕' ? T.amber : T.green, marginBottom: 8, lineHeight: 1.4 }}>{msg}</div>}

          {data && Object.keys(data).length === 0 ? <div style={{ color: T.muted, fontSize: 12, padding: '6px 0' }}>Loading…</div>
            : err ? <div style={{ color: T.amber, fontSize: 12, padding: '6px 0' }}>Couldn’t load ({err}). Check the owner code in this panel.</div>
            : refs.length === 0 ? <div style={{ color: T.muted, fontSize: 12, padding: '6px 0' }}>No referral codes yet — create one above.</div>
            : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead><tr>
                    <th style={{ ...th, textAlign: 'left' }}>Code</th>
                    <th style={th}>Qual</th><th style={th}>Owed</th>
                    <th style={th}>Earned</th><th style={th}>Paid subs</th><th style={th}>Free</th>
                  </tr></thead>
                  <tbody>
                    {refs.map(t => (
                      <tr key={t.ref_code} onClick={() => markPaid(t)} style={{ borderTop: `1px solid ${T.border}`, cursor: 'pointer' }}>
                        <td style={{ ...td, textAlign: 'left', fontWeight: 800, textTransform: 'uppercase' }}>{t.ref_code}</td>
                        <td style={{ ...td, color: T.green, fontWeight: 800 }}>{t.qualified || 0}</td>
                        <td style={{ ...td, color: t.owed > 0 ? T.green : T.muted, fontWeight: 800 }}>${t.owed || 0}</td>
                        <td style={td}>${t.earned || 0}</td>
                        <td style={td}>{t.paid_active || 0}</td>
                        <td style={td}>{t.referred || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ fontSize: 10, color: T.faint, marginTop: 8, lineHeight: 1.4 }}>
                  Paid subs = active/trialing subscribers tagged to the code. Owed = earned − already paid. Tap a row to record a payout.
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  )
}

export function OpsSheet({ season, week, onClose }) {
  const [busy, setBusy] = useState('')
  const [log, setLog] = useState([])
  const [val, setVal] = useState(null)
  const [jobs, setJobs] = useState(null)
  const [code, setCode] = useState(getNFLOps())
  const [needCode, setNeedCode] = useState(false)
  const [roster, setRoster] = useState(null)   // roster readiness {season, status}
  const [odds, setOdds] = useState(null)       // odds coverage {rows, priced, week}
  const [cov, setCov] = useState(null)          // board coverage {teams_scheduled, teams_boarded}
  const [pool, setPool] = useState(null)        // season-projection funnel (draft board pool)
  const [ready, setReady] = useState(null)      // full input-readiness list [{input, season, status, rows}]
  const [audit, setAudit] = useState(null)      // board audit {flagged, findings} (undefined=loading)
  const [mkt, setMkt] = useState(null)          // market-calibration audit vs the book
  const [scr, setScr] = useState({ name: '', reason: 'Scratched' })  // scratch-a-player form
  const [scrMsg, setScrMsg] = useState('')      // scratch result line
  const [injScr, setInjScr] = useState(null)    // injured-out scratches {count, players[]}
  const [injOpen, setInjOpen] = useState(false)

  const loadStatus = () => getNFLStatus(season, week).then(d => {
    const rd = d?.readiness || []
    const r = rd.find(x => x.input === 'Rosters')
    if (r) setRoster(r)
    // The backend now includes an Injuries readiness row (with a "reason"); only synthesize
    // one from coverage as a fallback for an older backend that doesn't send it.
    const hasInj = rd.some(x => x.input === 'Injuries')
    const inj = (!hasInj && d?.coverage && !d.coverage.error)
      ? [{ input: 'Injuries', rows: d.coverage.injuries_total || 0, season,
           status: (d.coverage.injuries_total || 0) > 0 ? 'live' : 'missing' }]
      : []
    // Collapse any duplicate input (belt-and-suspenders against backend/frontend version
    // skew — a stale bundle + new backend could otherwise show two Injuries rows).
    const merged = [...rd, ...inj].filter((r, i, a) => a.findIndex(x => x.input === r.input) === i)
    if (merged.length) setReady(merged)
    if (d?.odds) setOdds(d.odds)
    if (d?.coverage) setCov(d.coverage)
    if (d?.season_pool) setPool(d.season_pool)
  })
  useEffect(() => { loadStatus() }, [season, week])
  // Injured-out scratches season to date — losses voided because the player's snap share
  // collapsed (he exited the game). Surfaced here so Ops can see + audit them at a glance.
  useEffect(() => { getNFLScorecard(season, 0).then(d => setInjScr(d?.injury_scratched || null)).catch(() => {}) }, [season])

  const run = async (job, label) => {
    setBusy(job)
    const res = await runNFLJob(job, season)
    const ok = res.ok && (res.body?.status === 'started' || res.body?.status === 'ok')
    if (res.status === 401) setNeedCode(true)     // login code lacks owner rights — ask once
    setLog(l => [{ ok, text: ok ? `Started: ${label}` : `Failed: ${label} — ${res.body?.detail || res.status}` }, ...l].slice(0, 8))
    setBusy('')
    if (['rosters', 'rollover', 'pull_lines'].includes(job)) setTimeout(loadStatus, 5000)   // re-check freshness / odds
  }

  // Scratch (or restore) a player for this week — suspensions, late scratches, cuts the
  // injury feed never reports. Writes an OUT override; the board drops him on the next
  // project run (so we nudge a project after a successful scratch).
  const scratch = async (remove) => {
    const nm = scr.name.trim()
    if (!nm) { setScrMsg('Enter a player name first.'); return }
    setBusy('scratch'); setScrMsg('')
    const res = await scratchNFLPlayer(nm, { reason: scr.reason || 'Scratched', remove, season, week })
    if (res.status === 401) setNeedCode(true)
    const b = res.body || {}
    if (res.ok && b.ok) {
      setScrMsg(remove ? `✓ Restored ${b.player || nm}` : `✓ Scratched ${b.player || nm} (Wk ${week}) — re-run “Run full pipeline” to drop him from the board.`)
      if (!remove) setScr(s => ({ ...s, name: '' }))
    } else {
      setScrMsg(`✕ ${b.note || b.detail || 'Could not update — check the name / owner code.'}`)
    }
    setBusy('')
  }

  const saveCode = () => { setNFLOps(code); setNeedCode(false)
    setLog(l => [{ ok: true, text: 'Owner code saved — tap a job again.' }, ...l].slice(0, 8)) }

  const runMarketAudit = async () => {
    setBusy('mkt'); setMkt('loading')
    setMkt(await getNFLMarketAudit(season, week))
    setBusy(null)
  }
  const runAudit = async () => {
    setBusy('audit'); setAudit('loading')
    const r = await getNFLAudit(season, week)
    if (r.status === 401) { setNeedCode(true); setAudit(null) }
    else setAudit(r.body || { findings: [] })
    setBusy('')
  }

  const check = async () => {
    setBusy('val'); setVal(null)
    const d = await getNFLValidation(season)
    // /validation returns markets as a DICT keyed by prop; normalize to an array.
    const mk = d?.markets
    const arr = Array.isArray(mk) ? mk
      : mk && typeof mk === 'object' ? Object.entries(mk).map(([market, c]) => ({ market, ...c }))
      : (d?.rows || [])
    setVal(arr)
    setJobs(d?.jobs || [])
    setBusy('')
  }

  const btn = (disabled) => ({
    display: 'block', width: '100%', textAlign: 'left', cursor: disabled ? 'default' : 'pointer',
    background: T.card, border: `1px solid ${T.border}`, borderRadius: 11, padding: '12px 14px',
    marginBottom: 8, color: T.text, opacity: disabled ? 0.6 : 1,
  })
  const verdictColor = v => v === 'PASS' ? T.green : v === 'REVIEW' ? T.amber : T.muted

  return (
    <Sheet onClose={onClose}>
      <div style={{ padding: '8px 16px 24px' }}>
        <div style={{ fontSize: 19, fontWeight: 900, marginTop: 6 }}>Ops</div>
        <div style={{ fontSize: 12, color: T.muted, margin: '3px 0 14px', lineHeight: 1.5 }}>
          One-tap pipeline controls — owner only. Jobs run in the background; use
          <b style={{ color: T.text }}> Check results</b> after a minute or two.
        </div>

        {/* Post cards — pull the whole social set from admin, same as baseball. */}
        <NflPostCards season={season} week={week} />

        {/* Referrals — the in-app referral program view (earned / owed / mark paid / mint codes). */}
        <ReferralsOps />

        {/* Owner code — shown once when the logged-in code lacks owner rights. Saved
            to the device, so after this the buttons are one-tap forever. */}
        {(needCode || getNFLOps()) && (
          <div style={{ background: T.card2, border: `1px solid ${needCode ? T.amber : T.border}`, borderRadius: 11, padding: '12px 14px', marginBottom: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: needCode ? T.amber : T.text, marginBottom: 6 }}>
              {needCode ? 'Enter your owner code once' : 'Owner code saved'}
            </div>
            {needCode && <div style={{ fontSize: 11, color: T.muted, marginBottom: 8, lineHeight: 1.5 }}>
              Your login can read the board but not run jobs. Paste your master/owner access code — it's saved on this device, so you only do this once.
            </div>}
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={code} onChange={e => setCode(e.target.value)} type="password" placeholder="owner access code"
                style={{ flex: 1, minWidth: 0, background: T.card, border: `1px solid ${T.border}`, borderRadius: 8, padding: '9px 11px', color: T.text, fontSize: 13 }} />
              <button onClick={saveCode} style={{ background: T.green, color: '#04140C', border: 'none', borderRadius: 8, padding: '9px 14px', fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>Save</button>
            </div>
          </div>
        )}

        {/* Roster freshness — flags when the board is still on last season's rosters
            (e.g. a QB showing on his OLD team), with a one-tap fix. */}
        {roster && (
          <div style={{ background: roster.status === 'live' ? T.greenDim : T.amberDim,
            border: `1px solid ${roster.status === 'live' ? T.green : T.amber}55`, borderRadius: 11,
            padding: '10px 13px', marginBottom: 12, fontSize: 12, lineHeight: 1.5 }}>
            {roster.status === 'live'
              ? <span style={{ color: T.green }}><b>✓ Rosters loaded · {roster.season}</b> ({roster.rows} players){roster.refreshed ? <> · pulled <b style={{ color: T.text }}>{new Date(roster.refreshed).toLocaleString()}</b></> : ''}. Only as current as the nflverse feed — a same-day signing can lag a day.</span>
              : <span style={{ color: T.amber }}><b>⚠ Rosters are on {roster.season || 'last season'} data</b> — players may show their old team. Tap <b>Refresh rosters</b> to pull {season}.</span>}
          </div>
        )}

        {/* Odds coverage — proof the book-line pull is working (or why it isn't). */}
        {odds && (
          <div style={{ background: (odds.rows > 0) ? T.greenDim : T.card2,
            border: `1px solid ${(odds.rows > 0) ? `${T.green}55` : T.border}`, borderRadius: 11,
            padding: '10px 13px', marginBottom: 12, fontSize: 12, lineHeight: 1.5 }}>
            {odds.rows > 0
              ? <span style={{ color: T.green }}><b>✓ Book lines loaded · wk {odds.latest_week}</b> — {odds.rows} lines ({odds.two_sided_total} two-sided) · <b style={{ color: T.text }}>{odds.projections_with_edge}</b> priced with an edge.</span>
              : <span style={{ color: T.muted }}><b>No book lines yet.</b> NFL props post ~1–2 days before kickoff. Tap <b>Pull book lines</b> nearer game day (needs ODDS_API_KEY set in Railway).</span>}
          </div>
        )}

        {/* Board coverage — the number that explains a thin board. If most teams
            aren't scheduled, only a few players board and the grids fill with dashes. */}
        {cov && !cov.error && (
          <div style={{ background: cov.ok ? T.greenDim : T.amberDim,
            border: `1px solid ${cov.ok ? T.green : T.amber}55`, borderRadius: 11,
            padding: '10px 13px', marginBottom: 12, fontSize: 12, lineHeight: 1.5 }}>
            {cov.ok
              ? <span style={{ color: T.green }}><b>✓ Full slate · wk {cov.week}</b> — {cov.teams_scheduled}/32 teams, {cov.wr_boarded}/{cov.wr_pool} WRs boarded. Dashes on the grid are players genuinely below the model's volume threshold.</span>
              : <span style={{ color: T.amber }}>
                  <b>⚠ Thin board · wk {cov.week}</b> — {cov.teams_scheduled}/32 teams scheduled · {cov.wr_boarded}/{cov.wr_pool} WRs boarded{cov.injuries_out ? ` · ${cov.injuries_out} OUT` : ''}.
                  {cov.hint ? <><br/><span style={{ color: T.text }}>{cov.hint}</span></> : ' Run full pipeline.'}
                </span>}
          </div>
        )}

        {/* Data readiness — every input feeding the board at a glance, so the full
            health check lives in-app (no Railway logs / raw status JSON). Green = live
            current-season data; amber = last-season carryover (works, but not yet this
            year's coaching/roster/scheme); red = missing (a gap the board should not
            trust — e.g. an empty injury feed that fails OPEN). */}
        {ready?.length > 0 && (() => {
          const dot = st => st === 'live' ? T.green : st === 'missing' ? T.red : T.amber
          const label = st => st === 'live' ? 'live' : st === 'missing' ? 'not loaded' : 'carryover'
          const anyStale = ready.some(r => r.status !== 'live')
          return (
            <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 11,
              padding: '11px 13px', marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 9 }}>
                <span style={{ fontSize: 12, fontWeight: 800, color: T.text, letterSpacing: '0.03em' }}>Data readiness</span>
                <span style={{ fontSize: 10.5, color: anyStale ? T.amber : T.green }}>{anyStale ? 'some inputs on carryover' : 'all live'}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
                {ready.map((r, i) => (
                  <div key={i}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12 }}>
                      <span style={{ width: 8, height: 8, borderRadius: '50%', flexShrink: 0, background: dot(r.status) }} />
                      <span style={{ flex: 1, color: T.text }}>{r.input}</span>
                      <span style={{ fontSize: 10.5, color: T.muted, fontFamily: T.mono }}>
                        {r.status !== 'missing' && r.season ? `${r.season} · ` : ''}{(r.rows || 0).toLocaleString()} rows
                      </span>
                      <span style={{ fontSize: 10, fontWeight: 700, color: dot(r.status), minWidth: 62, textAlign: 'right' }}>{label(r.status)}</span>
                    </div>
                    {/* Why a feed is stale/empty — the last ingest diagnostic (depth / injuries) */}
                    {r.reason && <div style={{ fontSize: 10, color: T.muted, margin: '2px 0 0 16px', lineHeight: 1.4, fontStyle: 'italic' }}>{r.reason}</div>}
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 10, color: T.muted, marginTop: 9, lineHeight: 1.45 }}>
                Amber inputs are last-season carryover — the board works, but this year's coaching / roster / scheme changes aren't reflected yet. Red = a data feed hasn't loaded yet.
              </div>
            </div>
          )
        })()}

        {/* Board audit — a full player-by-player anomaly scan on demand. Catches the
            "that seems wrong" cases (projection fighting a sharp market, OUT-shown-active,
            ghost, implausible value, duplicate) across the whole board in one tap. */}
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 11, padding: '11px 13px', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 800, color: T.text }}>Board audit</div>
              <div style={{ fontSize: 10.5, color: T.muted, marginTop: 2 }}>Scan every player for anomalies · wk {week}</div>
            </div>
            <button onClick={runAudit} disabled={busy === 'audit'} style={{ background: busy === 'audit' ? T.card2 : T.green,
              color: busy === 'audit' ? T.muted : '#04140C', border: 'none', borderRadius: 8, padding: '8px 14px',
              fontWeight: 800, fontSize: 12, cursor: busy === 'audit' ? 'default' : 'pointer' }}>
              {busy === 'audit' ? 'Scanning…' : 'Run audit'}</button>
          </div>
          {audit && audit !== 'loading' && (
            <div style={{ marginTop: 11 }}>
              {!audit.findings?.length ? (
                <div style={{ fontSize: 12, color: T.green }}>✓ No anomalies across {audit.projections || 0} projections — board looks clean.</div>
              ) : (<>
                <div style={{ fontSize: 11.5, color: T.amber, fontWeight: 700, marginBottom: 8 }}>
                  ⚠ {audit.flagged} of {audit.projections} projections flagged — highest severity first
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 7, maxHeight: 320, overflowY: 'auto' }}>
                  {audit.findings.map((f, i) => (
                    <div key={i} style={{ background: T.card2, border: `1px solid ${f.severity >= 60 ? `${T.red}55` : T.border}`,
                      borderRadius: 9, padding: '8px 10px' }}>
                      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
                        <span style={{ fontSize: 12.5, fontWeight: 700, color: T.text }}>{f.name}
                          <span style={{ fontSize: 10.5, color: T.muted, fontWeight: 400 }}> {[f.pos, f.team, f.opp ? `vs ${teamNick(f.opp)}` : ''].filter(Boolean).join(' · ')}</span></span>
                        <span style={{ fontSize: 10, fontWeight: 800, color: f.severity >= 60 ? T.red : T.amber }}>{f.market}</span>
                      </div>
                      <div style={{ fontSize: 11, color: T.muted2, marginTop: 3, lineHeight: 1.4 }}>{f.reason}</div>
                    </div>
                  ))}
                </div>
              </>)}
            </div>
          )}
        </div>

        {/* Market audit — how far our board sits from the sharp market we ingest. Game
            lines (our spread/total vs the book) and props (our mean vs the book line),
            each with magnitude (MAE) and signed bias (are we systematically high/low). */}
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 11, padding: '11px 13px', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 800, color: T.text }}>Market audit</div>
              <div style={{ fontSize: 10.5, color: T.muted, marginTop: 2 }}>Our lines vs the sharp book · wk {week}</div>
            </div>
            <button onClick={runMarketAudit} disabled={busy === 'mkt'} style={{ background: busy === 'mkt' ? T.card2 : T.green,
              color: busy === 'mkt' ? T.muted : '#04140C', border: 'none', borderRadius: 8, padding: '8px 14px',
              fontWeight: 800, fontSize: 12, cursor: busy === 'mkt' ? 'default' : 'pointer' }}>
              {busy === 'mkt' ? 'Comparing…' : 'Run'}</button>
          </div>
          {mkt && mkt !== 'loading' && (() => {
            const biasCol = (b, scale) => b == null ? T.muted : Math.abs(b) < scale ? T.green : Math.abs(b) < scale * 2.2 ? T.amber : T.red
            const gl = mkt.game_lines || {}, sp = gl.spread || {}, tt = gl.total || {}
            const props = mkt.props || {}, pk = Object.keys(props)
            const cell = { background: T.card2, borderRadius: 8, padding: '8px 10px', flex: 1 }
            return (
              <div style={{ marginTop: 11 }}>
                {gl.priced_games ? (
                  <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                    <div style={cell}>
                      <div style={{ fontSize: 10, color: T.muted, letterSpacing: '0.05em' }}>SPREAD vs book</div>
                      <div style={{ fontSize: 13, fontWeight: 800, color: biasCol(sp.bias, 1.0), fontFamily: T.mono }}>
                        bias {sp.bias > 0 ? '+' : ''}{sp.bias ?? '—'}</div>
                      <div style={{ fontSize: 10, color: T.muted }}>MAE {sp.mae ?? '—'} · {sp.n || 0} gm</div>
                    </div>
                    <div style={cell}>
                      <div style={{ fontSize: 10, color: T.muted, letterSpacing: '0.05em' }}>TOTAL vs book</div>
                      <div style={{ fontSize: 13, fontWeight: 800, color: biasCol(tt.bias, 1.0), fontFamily: T.mono }}>
                        bias {tt.bias > 0 ? '+' : ''}{tt.bias ?? '—'}</div>
                      <div style={{ fontSize: 10, color: T.muted }}>MAE {tt.mae ?? '—'} · {tt.n || 0} gm</div>
                    </div>
                  </div>
                ) : <div style={{ fontSize: 11.5, color: T.muted, marginBottom: 10 }}>No book game lines loaded yet.</div>}

                {pk.length > 0 && (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 10.5, color: T.muted, marginBottom: 5 }}>Prop mean vs book line (bias %, + = we run high)</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      {pk.map(k => { const d = props[k]; return (
                        <div key={k} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 11.5 }}>
                          <span style={{ color: T.text }}>{k} <span style={{ color: T.muted }}>· {d.n}</span></span>
                          <span style={{ fontFamily: T.mono, fontWeight: 700, color: biasCol(d.bias_pct, 4) }}>
                            {d.bias_pct > 0 ? '+' : ''}{d.bias_pct}%<span style={{ color: T.muted, fontWeight: 400 }}> ·{d.mae_pct}% off</span></span>
                        </div>) })}
                    </div>
                  </div>
                )}

                {mkt.prop_worst?.length > 0 && (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 10.5, color: T.muted, marginBottom: 5 }}>Biggest prop over-projections (where the bias comes from)</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 220, overflowY: 'auto' }}>
                      {mkt.prop_worst.map((r, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, background: T.card2, borderRadius: 8, padding: '6px 10px', fontSize: 11 }}>
                          <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            <b style={{ color: T.text }}>{r.name}</b> <span style={{ color: T.muted }}>{r.pos} · {r.market}</span>
                            <span style={{ color: T.muted2 }}> · {r.our} vs {r.line}</span>
                          </span>
                          <span style={{ fontFamily: T.mono, fontWeight: 800, color: biasCol(r.diff_pct, 20), flexShrink: 0 }}>{r.diff_pct > 0 ? '+' : ''}{r.diff_pct}%</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {gl.worst?.length > 0 && (<>
                  <div style={{ fontSize: 10.5, color: T.muted, marginBottom: 5 }}>Biggest game-line disagreements</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5, maxHeight: 200, overflowY: 'auto' }}>
                    {gl.worst.slice(0, 8).map((r, i) => (
                      <div key={i} style={{ background: T.card2, borderRadius: 8, padding: '6px 10px', fontSize: 11 }}>
                        <span style={{ fontWeight: 700, color: T.text }}>{r.away} @ {r.home}</span>
                        {r.spread_diff != null && <span style={{ color: T.muted2, marginLeft: 8 }}>spread ours {r.our_spread} vs {r.book_spread} <b style={{ color: T.amber }}>({r.spread_diff > 0 ? '+' : ''}{r.spread_diff})</b></span>}
                        {r.total_diff != null && <span style={{ color: T.muted2, marginLeft: 8 }}>tot {r.our_total} vs {r.book_total} <b style={{ color: T.amber }}>({r.total_diff > 0 ? '+' : ''}{r.total_diff})</b></span>}
                      </div>
                    ))}
                  </div>
                </>)}
                <div style={{ fontSize: 10, color: T.faint, marginTop: 8, lineHeight: 1.4 }}>
                  Benchmark = the sharp book. Bias ≈ 0 is well-calibrated; a persistent bias is a model tell, scatter is variance.
                </div>
              </div>
            )
          })()}
        </div>

        {/* Season-projection funnel — the DRAFT board pool. A thin pool over-ranks
            scarce positions (the "McBride at #7" artifact); this shows the exact stage
            where players are lost: logs → on current roster → enough games → projected. */}
        {pool && !pool.error && pool.by_pos && (
          <div style={{ background: pool.ok ? T.greenDim : T.amberDim,
            border: `1px solid ${pool.ok ? T.green : T.amber}55`, borderRadius: 11,
            padding: '10px 13px', marginBottom: 12, fontSize: 12, lineHeight: 1.5 }}>
            {pool.ok
              ? <span style={{ color: T.green }}><b>✓ Draft pool healthy</b> — {pool.total_projected} players projected for the draft board.</span>
              : <span style={{ color: T.amber }}><b>⚠ Thin draft pool</b> — {pool.total_projected} projected. Ranks approximate until reloaded.</span>}
            <div style={{ marginTop: 7, display: 'grid', gridTemplateColumns: '34px repeat(4,1fr)', gap: '2px 6px',
              fontFamily: T.mono, fontSize: 10.5, color: T.muted }}>
              <span></span><span>logs</span><span>rostr</span><span>games</span><span style={{ color: T.text }}>proj</span>
              {['QB', 'RB', 'WR', 'TE'].map(p => { const st = pool.by_pos[p] || {}; return (
                <React.Fragment key={p}>
                  <span style={{ color: T.text, fontWeight: 800 }}>{p}</span>
                  <span>{st.has_logs ?? '—'}</span>
                  <span style={{ color: (st.on_roster < st.has_logs * 0.5) ? T.amber : T.muted }}>{st.on_roster ?? '—'}</span>
                  <span>{st.enough_games ?? '—'}</span>
                  <span style={{ color: T.text, fontWeight: 700 }}>{(st.projected || 0) + (st.rookie || 0)}</span>
                </React.Fragment>
              )})}
            </div>
            {pool.hint && <div style={{ color: T.text, marginTop: 7 }}>{pool.hint}</div>}
          </div>
        )}

        {/* Injured-out scratches — losses the model-line record voided because the player's snap
            share collapsed (he exited the game). Auditable: tap to see exactly who. */}
        {injScr && (
          <div style={{ border: `1px solid ${T.border}`, borderRadius: 12, padding: '12px 13px', marginBottom: 10, background: T.card }}>
            <button onClick={() => setInjOpen(o => !o)} style={{ display: 'flex', width: '100%', alignItems: 'center',
              justifyContent: 'space-between', background: 'transparent', border: 'none', cursor: 'pointer', color: T.text, padding: 0 }}>
              <span style={{ fontSize: 13, fontWeight: 800 }}>🩹 Injured-out scratched · {season}</span>
              <span style={{ fontSize: 13, fontWeight: 900, fontFamily: T.mono, color: injScr.count ? T.amber : T.muted }}>
                {injScr.count}{(injScr.players || []).length ? ` ${injOpen ? '▾' : '▸'}` : ''}</span>
            </button>
            <div style={{ fontSize: 11, color: T.muted, marginTop: 3, lineHeight: 1.4 }}>
              Losses voided — player exited the game (snap-share collapse), so it wasn't a fair miss.
            </div>
            {injOpen && (injScr.players || []).map((p, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11.5, padding: '4px 0',
                borderTop: i ? `1px solid ${T.border}` : 'none', marginTop: i ? 0 : 6, color: T.muted2 }}>
                <span>{p.name} <span style={{ color: T.muted }}>· {playText(p.market, p.line)}</span></span>
                <span style={{ color: T.faint, fontFamily: T.mono }}>Wk {p.week}</span>
              </div>
            ))}
          </div>
        )}

        {/* Scratch a player — mark OUT for this week (suspensions, late scratches, cuts the
            injury feed misses). Drops him from the board + promotes the next man up. */}
        <div style={{ border: `1px solid ${T.border}`, borderRadius: 12, padding: '12px 13px', marginBottom: 10, background: T.card }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: T.text }}>Scratch a player · Week {week}</div>
          <div style={{ fontSize: 11, color: T.muted, margin: '2px 0 9px', lineHeight: 1.4 }}>
            Mark a player OUT the feed missed — suspension, late inactive, cut. Drops him from the board and promotes his backup.
          </div>
          <input value={scr.name} onChange={e => setScr(s => ({ ...s, name: e.target.value }))}
            placeholder="Player name (e.g. Josh Jacobs)"
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 11px', borderRadius: 9, marginBottom: 7,
              background: T.card2, border: `1px solid ${T.border2}`, color: T.text, fontSize: 13 }} />
          <input value={scr.reason} onChange={e => setScr(s => ({ ...s, reason: e.target.value }))}
            placeholder="Reason (Suspended / Cut / Inactive)"
            style={{ width: '100%', boxSizing: 'border-box', padding: '9px 11px', borderRadius: 9, marginBottom: 8,
              background: T.card2, border: `1px solid ${T.border2}`, color: T.text, fontSize: 13 }} />
          <div style={{ display: 'flex', gap: 7 }}>
            <button disabled={!!busy} onClick={() => scratch(false)} style={{ flex: 1, padding: '9px 0', borderRadius: 9,
              cursor: busy ? 'default' : 'pointer', fontWeight: 800, fontSize: 12.5, border: `1px solid ${T.red}`,
              background: `${T.red}18`, color: T.red }}>{busy === 'scratch' ? '…' : 'Scratch (Out)'}</button>
            <button disabled={!!busy} onClick={() => scratch(true)} style={{ flex: 1, padding: '9px 0', borderRadius: 9,
              cursor: busy ? 'default' : 'pointer', fontWeight: 800, fontSize: 12.5, border: `1px solid ${T.border2}`,
              background: T.card2, color: T.muted }}>Restore</button>
          </div>
          {scrMsg && <div style={{ fontSize: 11.5, color: scrMsg[0] === '✓' ? T.green : T.amber, marginTop: 8, lineHeight: 1.4 }}>{scrMsg}</div>}
        </div>

        {OPS_JOBS.map(([job, label, desc]) => (
          <button key={job} disabled={!!busy} onClick={() => run(job, label)} style={btn(!!busy)}>
            <div style={{ fontWeight: 800, fontSize: 14 }}>{busy === job ? 'Starting…' : label}</div>
            <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{desc}</div>
          </button>
        ))}

        <div style={{ fontSize: 11, color: T.muted, margin: '4px 0 12px', lineHeight: 1.5 }}>
          Pre-season order: <b style={{ color: T.text }}>full pipeline</b> → wait ~2 min → backtest → refit → backtest.
        </div>

        <button disabled={busy === 'val'} onClick={check} style={{
          display: 'block', width: '100%', cursor: 'pointer', background: T.greenDim,
          border: `1px solid ${T.green}`, borderRadius: 11, padding: '12px', color: T.green,
          fontWeight: 800, fontSize: 14, marginBottom: 12,
        }}>{busy === 'val' ? 'Checking…' : 'Check results'}</button>

        {/* Job status — so 'Check results' distinguishes running / done / failed
            instead of an ambiguous empty scorecard while the backtest churns. */}
        {jobs?.length > 0 && (() => {
          const jc = st => st === 'ok' ? T.green : st === 'error' ? T.red : T.amber
          const jlabel = st => st === 'ok' ? '✓ done' : st === 'error' ? '✕ failed' : '● running…'
          const running = jobs.some(j => j.status === 'running')
          return (
            <div style={{ background: T.card2, border: `1px solid ${running ? T.amber : T.border}`, borderRadius: 11, padding: '10px 13px', marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: T.muted, letterSpacing: '0.05em', marginBottom: 6 }}>RECENT JOBS</div>
              {jobs.slice(0, 4).map((j, i) => (
                <div key={i} style={{ padding: '4px 0' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', fontSize: 12 }}>
                    <span style={{ fontWeight: 700, color: T.text }}>{j.job}
                      {j.duration_s != null && <span style={{ color: T.muted, fontWeight: 400 }}> · {Math.round(j.duration_s)}s</span>}</span>
                    <span style={{ color: jc(j.status), fontWeight: 800 }}>{jlabel(j.status)}</span>
                  </div>
                  {j.detail && (
                    <div style={{ fontSize: 11, color: j.status === 'error' ? T.red : T.muted, marginTop: 2, fontFamily: T.mono, lineHeight: 1.4 }}>
                      {j.detail}
                    </div>
                  )}
                </div>
              ))}
              {running && <div style={{ fontSize: 11, color: T.amber, marginTop: 6 }}>The 4-season backtest can take several minutes — check again shortly.</div>}
            </div>
          )
        })()}

        {val && (val.length ? (
          <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 11, overflow: 'hidden', marginBottom: 12 }}>
            {val.map((mk, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '10px 13px', borderTop: i ? `1px solid ${T.border}` : 'none' }}>
                <span style={{ fontSize: 13, fontWeight: 700 }}>{mk.market || mk.prop || mk.name}
                  {mk.plays != null && <span style={{ fontSize: 10.5, color: T.muted, fontWeight: 400, marginLeft: 6 }}>{mk.plays} plays</span>}</span>
                <span style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                  {mk.cal_err != null && <span style={{ fontSize: 11, color: T.muted, fontFamily: T.mono }}>{Number(mk.cal_err).toFixed(2)}pp</span>}
                  <span style={{ fontSize: 11, fontWeight: 800, color: verdictColor(mk.verdict) }}>{mk.verdict || '—'}</span>
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ fontSize: 12, color: T.muted, marginBottom: 12 }}>
            {jobs?.some(j => j.status === 'running')
              ? 'Backtest still running — results will fill in here when it finishes.'
              : 'No validation yet — this builds as the season’s results settle. Check back soon.'}
          </div>
        ))}

        {log.length > 0 && (
          <div style={{ marginTop: 4 }}>
            {log.map((l, i) => (
              <div key={i} style={{ fontSize: 12, color: l.ok ? T.green : T.red, padding: '3px 0', fontFamily: T.mono }}>
                {l.ok ? '✓ ' : '✕ '}{l.text}
              </div>
            ))}
          </div>
        )}
      </div>
    </Sheet>
  )
}
